<template>
  <div class="app-main-inner-page">
    <cargo-dialog
      ref="dialog"
      v-el-drag-dialog
      custom-class="write-off-dialog write-off-dialog-margin"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :show-close="false"
      :title="title"
      width="1150px"
      :can-maximize="true"
      :can-minimize="true"
      @close="cancel"
      @fullscreen="fullscreenChange"
    >
      <div class="app-main-inner-row row-grid-dialog" style="width: 100%; min-height: 210px; padding-bottom: 0;">
        <cargo-left-right-resize
          style="width: 100%;"
          :show-right="dgCharge.show"
          :left-style="{'min-width': '20%'}"
          :right-style="{'min-width': '80%'}"
        >
          <div slot="left">
            <span v-if="properties.isHedge">{{ $t('WriteOff.receivables') }}</span>
            <div class="app-main-inner-row row-grid-dialog" style="min-height:210px; padding: 0;">

              <cargo-ag-grid-wrapper
                :config-module="dgCharge.show?'':'19070801'"
                :show-side-bar="!dgCharge.show"
                :grid-options="dgGroup.gridOptions"
                :column-defs="dgGroup.columnDefs"
                :row-data="properties.selectedEntities"
                :auto-fit-content="false"
                style="width:100%;min-height: 180px"
                @gridReady="onGridReady_dgGroup"
              />
            </div>
            <span v-if="properties.isHedge">{{ $t('WriteOff.payables') }}</span>
            <div
              v-if="properties.isHedge"
              class="app-main-inner-row row-grid-dialog"
              style="min-height: 180px; padding: 0;"
            >

              <cargo-ag-grid-wrapper
                :config-module="dgCharge.show?'':'19070802'"
                :show-side-bar="!dgCharge.show"
                :grid-options="dgHedge.gridOptions"
                :column-defs="dgHedge.columnDefs"
                :row-data="properties.selectedEntitiesHedge"
                :auto-fit-content="false"
                style="width:100%;min-height: 180px"
                @gridReady="onGridReady_dgHedge"
              />
            </div>
          </div>
          <div
            slot="right"
            class="app-main-inner-row row-grid-dialog"
            style="height: 100%; min-height: 180px; padding: 0;"
          >

            <cargo-ag-grid
              config-module="19070803"
              :grid-options="dgCharge.gridOptions"
              :column-defs="dgCharge.columnDefs"
              :row-data="dgChargeRowData"
              style="width:100%;"
              @gridReady="onGridReady_dgCharge"
            />
          </div>
        </cargo-left-right-resize>
      </div>
      <div class="app-main-inner-row">
        <div style="width: 100%;">
          <div class="inner-row-border-bottom" style="width: 100%; display:flex; justify-content: space-between;">
            <!--    todo: &lt; or &gt; 对冲销账时对比应收应付   -->
            <div style="display: inline-block;text-align: right;margin-right: -10px">
              <span>{{ $t('WriteOff.total') }}</span>
              <charge-currency-total-group
                v-if="reCalc"
                :key="1"
                mode="group"
                type="revenueAbs"
                data-field="amount"
                rate-field="writeoffRate"
                currency-field="currency"
                ar-field="isReceivable"
                source="Writeoff"
                :data-provider="properties.allEntities"
                :amount-to-currency="currencyTotal"
              />
            </div>
            <span v-if="properties.isHedge" style="color: red;padding-left: 10px;">{{ lbArAlert }}</span>
            <div v-show="dgCharge.show===true">
              <el-checkbox v-model="cbConfirmedCharge" no="1" @change="confirmedChargeChangeHandler"><span>{{
                $t('WriteOff.confirmedCharge')
              }}</span></el-checkbox>
            </div>

            <div style="display: inline-block;text-align: right;margin-right: -10px">
              <span v-show="dgCharge.show===true">{{ $t('WriteOff.subTotal') }}</span>
              <charge-currency-total-group
                v-if="reCalc"
                v-show="dgCharge.show===true"
                :key="2"
                mode="group"
                type="revenueAbs"
                data-field="currentVerifiedAmount"
                rate-field="writeoffRate"
                currency-field="currency"
                ar-field="isReceivable"
                source="Writeoff"
                :data-provider="subtotalGroup"
                :amount-to-currency="currencyTotal"
              />
            </div>
          </div>
          <el-form :inline="true" :label-width="$selectByLang('60px', '90px')" label-position="left">
            <div class="inner-row-border-bottom">
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('WriteOff.rateBy')" :label-width="$selectByLang('', '140px')">
                  <el-radio-group v-model="rateBy" no="2" @change="rateByChangeHandler">
                    <el-radio v-if="[2,3,4,5].includes(properties.writeOffMode)" label="invoice">{{
                      rateByInvoice
                    }}
                    </el-radio>
                    <el-radio label="average">{{ $t('WriteOff.rateByAverage') }}</el-radio>
                    <el-radio v-if="properties.writeOffMode === 1" label="charge">{{ $t('WriteOff.rateByCharge') }} </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  v-if="rateBy==='average' && properties.otherCurrencyRate.length>0"
                  :label="$t('WriteOff.otherCurrency')"
                  :label-width="$selectByLang('', '100px')"
                >
                  <span v-if="properties.otherCurrencyRate.length>0" style="padding-right: 6px;"><b>{{
                    lbOtherCurrency1
                  }}</b></span>
                  <num-input
                    v-if="properties.otherCurrencyRate.length>0"
                    v-model="txtOtherRate1"
                    no="3"
                    style="width: 100px;"
                    :precision="8"
                    :truncated-precision="txtOtherRate1Precision"
                    :min="0"
                    :max="999999999999"
                    @change="otherRate1ChangeHandler"
                  />
                  <span v-if="properties.otherCurrencyRate.length>1" style="padding:0 6px;"><b>{{
                    lbOtherCurrency2
                  }}</b></span>
                  <num-input
                    v-if="properties.otherCurrencyRate.length>1"
                    v-model="txtOtherRate2"
                    no="4"
                    style="width: 100px;"
                    :precision="8"
                    :truncated-precision="txtOtherRate2Precision"
                    :min="0"
                    :max="999999999999"
                    @change="otherRate2ChangeHandler"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item class="el-form-item-w180">
                  <line-label slot="label" :label="$t('WriteOff.lastTimeBalance')" />
                  <el-input-number
                    v-model="totalAmount"
                    no="5"
                    controls-position="right"
                    style="width: 140px;"
                    :disabled="true"
                    :precision="2"
                    :step="1"
                    :min="-999999999999"
                    :max="999999999999"
                  />
                </el-form-item>
                <el-form-item
                  class="el-form-item-w180 custom-el-form-item-color-red"
                >
                  <line-label slot="label" :label="$t('WriteOff.thisTimeWriteOff')" />
                  <el-input-number
                    v-model="totalVerifyAmount"
                    no="6"
                    controls-position="right"
                    style="width: 140px;"
                    :disabled="true"
                    :precision="2"
                    :step="1"
                    :min="-999999999999"
                    :max="999999999999"
                  />
                </el-form-item>
                <el-form-item
                  class="el-form-item-w180 custom-el-form-item-color-green"
                >
                  <line-label slot="label" :label="$t('WriteOff.thisTimeBalance')" />
                  <el-input-number
                    v-model="totalRemainAmount"
                    no="7"
                    controls-position="right"
                    style="width: 140px;"
                    :disabled="true"
                    :precision="2"
                    :step="1"
                    :min="-999999999999"
                    :max="999999999999"
                  />
                </el-form-item>
                <el-form-item class="el-form-item-w180">
                  <line-label slot="label" :label="$t('WriteOff.preExchangeDifference')" />
                  <el-input-number
                    v-model="preExchangeDifference"
                    no="8"
                    controls-position="right"
                    style="width: 140px;"
                    :disabled="true"
                    :precision="2"
                    :step="1"
                    :min="-999999999999"
                    :max="999999999999"
                  />
                </el-form-item>
                <el-button
                  v-if="!properties.bankSlip"
                  v-show="showRecordButton"
                  type="primary"
                  no="9"
                  style="margin-right: 16px; position: absolute; right: 0;"
                  @click="useActualAmountRecordHandler"
                >{{ useActualAmountRecordLabel }}
                </el-button>
              </div>
            </div>
            <div class="inner-row-border-bottom">
              <cargo-left-right-resize :left-style="{'flex-grow': '0'}" style="min-height:100%">
                <div slot="left" :style="$selectByLang('max-width: 180px;min-width: 150px;', 'max-width: 210px;min-width: 180px;')">
                  <el-form-item
                    class="el-form-item-w180 custom-el-form-item-color-red"
                  >
                    <line-label slot="label" :label="isAr?$t('WriteOff.receiptAmount'):$t('WriteOff.paymentAmount')" />
                    <el-input-number
                      v-model="nsActualAmount"
                      no="10"
                      controls-position="right"
                      style="width: 120px;"
                      :precision="2"
                      :step="1"
                      :min="-999999999999"
                      :max="999999999999"
                      :disabled="rateBy !== 'average' && useReceiptRecord"
                      @change="nsActualAmountChangeHandler"
                    />
                  </el-form-item>
                  <el-form-item
                    class="el-form-item-w180 custom-el-form-item-color-green"
                  >
                    <line-label slot="label" :label="$t('WriteOff.exchangeGainsAndLosses')" />
                    <el-input-number
                      v-model="nsDiffChange"
                      no="11"
                      controls-position="right"
                      style="width: 120px;"
                      :precision="2"
                      :step="1"
                      :min="-999999999999"
                      :max="999999999999"
                    />
                  </el-form-item>
                  <el-form-item
                    class="el-form-item-w180 custom-el-form-item-color-green"
                  >
                    <line-label slot="label" :label="$t('WriteOff.financialCharges')" />
                    <el-input-number
                      v-model="nsFinancialCost"
                      no="12"
                      controls-position="right"
                      style="width: 120px;"
                      :precision="2"
                      :step="1"
                      :min="-999999999999"
                      :max="999999999999"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('WriteOff.oddment')" class="el-form-item-w180 custom-el-form-item-color-green">
                    <el-input-number
                      v-model="nsClearOdd"
                      no="13"
                      controls-position="right"
                      style="width: 120px;"
                      :precision="2"
                      :step="1"
                      :min="-999999999999"
                      :max="999999999999"
                    />
                  </el-form-item>
                  <template v-if="properties.writeOffFinanceChargeShareJob && viewSource === 'tabNonWriteOffList'">
                    <el-form-item>
                      <el-checkbox v-model="isFinanceChargeShareJob" :disabled="!nsFinancialCost">{{ $t('WriteOff.FinancialExpensesBeAllocated') }}</el-checkbox>
                    </el-form-item>
                    <el-form-item v-show="isFinanceChargeShareJob">
                      <div style="line-height: 14px;color: red;">{{ $t('WriteOff.FinanceChargeShareJobTip') }}</div>
                    </el-form-item>
                  </template>
                  <template v-if="showWhtTax && isFullWriteOff">
                    <el-form-item style="margin-top: 10px">
                      <span style="line-height: 14px;color: red;">{{ $t('Clearing.WhtDeduction') }}</span>
                      <span style="margin: 0 5px;">{{ whtCurrency }}</span>
                      <span>{{ whtAmount.toFixed(2) }}</span>
                    </el-form-item>
                    <div>
                      <span style="line-height: 14px;color: red;">{{ isAr ? $t('Clearing.ReceivableWHTTaxAmount') : $t('Clearing.PayableWHTTaxAmount') }}</span>
                      <span style="margin: 0 5px;">{{ whtCurrency }}</span>
                      <span>{{ ((Number(localAmountSum) || 0) - whtAmount).toFixed(2) }}</span>
                    </div>
                  </template>
                </div>
                <div slot="right">
                  <cargo-ag-grid
                    config-module="190707"
                    :show-side-bar="false"
                    :grid-options="actualAmountGrid.gridOptions"
                    :column-defs="actualAmountColumnDefs"
                    :row-data="actualAmountGrid.rowData"
                    style="width:100%;min-width: 900px;"
                    @gridReady="params=>{actualAmountGrid.gridApi=params.api}"
                  />
                </div>
              </cargo-left-right-resize>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('WriteOff.writeOffRemarks')" :label-width="$selectByLang('', '120px')" class="el-form-item-w365" :style="$selectByLang('', 'width: auto;')">
                <el-input
                  v-model="txtRemark"
                  no="14"
                  @dblclick.native="showAdvanceTextDialog($t('WriteOff.writeOffRemarks'),txtRemark,val=>{txtRemarkFinshHandlde(val)})"
                />
              </el-form-item>
              <el-form-item v-if="showWriteOffHeader" :label="$t('CargoMsg.Cargo_WriteOffHeader')">
                <cargo-advance-select
                  no="ourTitle"
                  :select-type="selectTypeNames.static_data_InvoiceTitle"
                  filterable
                  :cache="false"
                  :default-value="actualAmountTitle"
                  :static-options="ourInvoiceTitleArray"
                  @parentCallBack="actualAmountTitleChangeEvent"
                />
              </el-form-item>
              <el-form-item
                :label="isAr?$t('WriteOff.paymentReceivedDate'):$t('WriteOff.paymentDate')"
                :label-width="$selectByLang('', '140px')"
                class="el-form-item-date-w180"
                :style="$selectByLang('', 'width: auto;')"
              >
                <el-date-picker
                  v-model="dfAmountDate"
                  no="15"
                  type="date"
                  :clearable="false"
                  style="width: 120px;"
                  @change="dfAmountDateChangeHandler"
                />
              </el-form-item>
              <el-form-item>
                <span style="color: #1a61af;font-weight: bold;padding-left: 10px; font-size: 14px;">{{
                  $t('WriteOff.thisTimeWriteOff') + (isFinanceChargeShareJob ? $t('Clearing.WhenShareFinanceCost') : '') + '=' + (isAr ? $t('WriteOff.receiptAmount') : $t('WriteOff.paymentAmount')) + '+' + $t('WriteOff.exchangeGainsAndLosses') + (isFinanceChargeShareJob ? '' : '+' + $t('WriteOff.financialCharges')) + '+' + $t('WriteOff.oddment')
                }}</span>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <!--      </el-scrollbar>-->
      <div slot="footer">
        <el-button type="primary" :disabled="isLoading || isExecuting" no="16" @click="commitHandler">{{
          $t('WriteOff.confirmToWriteOff')
        }}
        </el-button>
        <el-button no="17" @click="cancel">{{ $t('WriteOff.cancel') }}</el-button>
      </div>
    </cargo-dialog>
    <!-- 实收实付 -->
    <actual-payment-dialog
      :visible="actualPaymentDialog.visible"
      @selected="selectedActualPayment"
    />
    <!-- 选择实收实付记录 弹窗 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="realSendReceiveDialog.visible"
      :title="$t('WriteOff.selectActualReceiptAndPayment')"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="app-main-content"
    >
      <write-off-search
        v-if="realSendReceiveDialog.visible"
        ref="writeOffSearch"
        config-module="510"
        grid-config-module="191002"
        :ar="isAr ? 1 : 0"
        :is-prepay="1"
        :account-id="searchAccountId"
        :row-selection-type="!properties.isHedge ? 'multiple' : 'single'"
        :is-real-send-receive="true"
        :show-simple="false"
        :remain-condition="true"
        dialog-height="height: 500px;"
        :is-dialog="true"
        @selectionChangedCallBack="selectionChangedCallBack"
      />
      <div slot="footer">
        <el-button type="primary" no="18" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="19" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 财务费用分摊弹窗 -->
    <finance-charge-share-dialog
      :visible.sync="financeChargeShareDialog.visible"
      :receivable="financeChargeShareDialog.receivable"
      :currency="financeChargeShareDialog.currency"
      :exchange-rate="financeChargeShareDialog.exchangeRate"
      :amount="financeChargeShareDialog.amount"
      :finance-charge-share-modify="financeChargeShareModify"
      @confirmCallback="financeChargeShareDialog.confirmCallback"
      @cancelCallback="financeChargeShareDialog.cancelCallback"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { BankUtils } from '@/class/cargo/model/utils/BankUtil'
import { ApiCacheManage } from '@/utils/commonUtil'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import lodash from 'lodash'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import actualPaymentDialog from './actualPaymentDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import { Once, multiply, sleep } from '@/utils/commonUtil'
import moment from 'moment'
import URL from '@/api/urlTranslator'
import * as writeoffApi from '@/api/act/writeoff'
import { getBankAccountList } from '@/api/bankAccount'
import { chargeWriteoff, pushWriteOffSap, chargeWriteoffByMultiple, generateSeqNoByKartenNumberRule, generateSeqNoByWriteOffRemarkNo } from '@/api/clearing/actualAmount'
// import { writeOffManualTriggerAndUpate } from '@/api/seaExport/seaExportJob'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import writeOffSearch from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffSearch'
import { formatNumberToThousands } from '@/utils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import { WriteOffModel } from '@/class/model/act/WriteOffModel'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import lang from '@/lang'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import FinanceChargeShareDialog from '@/views/cargo/v0/Clearing/components/Writeoff/FinanceChargeShareDialog'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import BigNumber from 'bignumber.js'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip.vue'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'WriteOffDialog',
  components: {
    cargoRichTextarea,
    specialCharacterTip,
    cargoLeftRightResize,
    actualPaymentDialog,
    ChargeCurrencyTotalGroup,
    CargoAdvanceSelect,
    writeOffSearch,
    CargoAgGridCommonInputEditor,
    CargoDialog,
    cargoAgGridWrapper,
    FinanceChargeShareDialog,
    NumInput
  },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true, default: lang.t('Clearing.Reconciliation') },
    /**
     * params.mode: 弹窗模式[default:0] 0-销账模式  1-对冲销账模式
     * params.writeOffMode: 销账模式[default:1] 1-费用 2-发票 3-账单 4-对账单 5-付款申请
     * params.hedgeWriteOffMode: 销账模式[default:null] 1-费用 2-发票 3-账单 4-对账单 5-付款申请
     */
    params: { type: Object, required: false },
    properties: { type: Object, required: true },
    viewSource: { type: String, default: '' }, // 引用页面
    location: { type: String, required: false },
    financeChargeShareModify: { type: Boolean, default: false } // 子应用财务费用分摊固定费用名称、结算对象、收付类型
  },
  data() {
    return {
      isInputZeroFee: false,
      allOurBankAccountArray: [],
      getBankAccountListCache: new ApiCacheManage(getBankAccountList, officeUuid => officeUuid), // getBankAccountList缓存管理
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      ourInvoiceTitleArray: [], // 我方发票抬头选项
      selectTypeNames: TYPE_NAMES,
      actualAmountTitle: '', // 销账抬头
      isLoading: false,
      dgGroup: {
        gridOptions: {
          onRowClicked: this.onRowClicked1,
          defaultColDef: {
            filter: false
          }
        },
        gridParams: {},
        gridApi: {},
        columnDefs: [],
        rowData: [{ name: this.$t('Clearing.Company1') }]
      },
      dgHedge: {
        gridOptions: {
          onRowClicked: this.onRowClicked2,
          defaultColDef: {
            filter: false
          }
        },
        gridParams: {},
        gridApi: {},
        columnDefs: [],
        rowData: [{ name: this.$t('Clearing.Company1') }]
      },
      dgCharge: {
        show: false,
        gridParams: {},
        gridOptions: {
          masterDetail: true,
          detailRowHeight: 105,
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          onRowGroupOpened: (e) => {
            this.setDgChareColumnDefs(e.api)
          },
          onRowDataChanged: (e) => {
            this.setDgChareColumnDefs(e.api)
          },
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: false
          },
          detailCellRendererParams: {
            detailGridOptions: {
              columnDefs: [
                {
                  headerName: this.$t('WriteOff.type'), field: 'isReceivable',
                  cellRenderer: (params) => {
                    return ColumnUtils.chargeReceivableLabelFun(params.value)
                  }, width: 100
                },
                { headerName: this.$t('WriteOff.currency'), field: 'currency', width: 100 },
                {
                  headerName: this.$t('WriteOff.writeOffExchangeRate'), field: 'writeoffRate',
                  cellRenderer: (params) => {
                    return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 8), 8)
                  }, width: 100
                },
                {
                  headerName: this.$t('WriteOff.amount'), field: 'amount',
                  cellRenderer: (params) => {
                    return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2), 2)
                  }, width: 125
                },
                {
                  headerName: this.$t('WriteOff.lastTimeBalance'), field: 'lastTimeRemainAmount',
                  cellRenderer: (params) => {
                    return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2), 2)
                  }, width: 125
                },
                {
                  headerName: this.$t('WriteOff.thisTimeWriteOff'), field: 'currentVerifiedAmount', width: 135,
                  cellRendererFramework: 'agGridColumnEdit',
                  custom: {
                    isEdit: true,
                    tag: 'el-input-number',
                    precision: 2,
                    valueChanged: p => {
                      this.onCellChange(p)
                    }
                  }
                },
                {
                  headerName: this.$t('WriteOff.thisTimeBalance'), field: 'currentRemainAmount', width: 135,
                  cellRendererFramework: 'agGridColumnEdit',
                  custom: {
                    isEdit: true,
                    tag: 'el-input-number',
                    precision: 2,
                    valueChanged: p => {
                      this.onCellChange(p)
                    }
                  }
                }
              ]
            },
            getDetailRowData: params => {
              params.successCallback([params.data])
            }
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowSelected: this.onRowSelected
        },
        gridApi: {},
        columnDefs: [
          {
            headerName: '',
            width: 50,
            checkboxSelection: true,
            pinned: 'left',
            lockPosition: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            headerCheckboxSelection: true,
            cellRenderer: 'agGroupCellRenderer'
          },
          {
            headerName: this.$t('WriteOff.businessNumber'),
            pinned: 'left',
            field: 'jobNo',
            width: 150,
            cellRenderer: 'agGroupCellRenderer'
          },
          { headerName: 'MBL', field: 'mbl', width: 110 },
          {
            headerName: this.$t('WriteOff.businessDate'), field: 'businessDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 90
          },
          {
            headerName: this.$t('WriteOff.chargeItem'), field: 'chargeItemId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }, width: 90
          },
          {
            headerName: this.$t('WriteOff.reconciliationStatus'), field: 'confirmState',
            cellRenderer: (params) => {
              return ColumnUtils.chargeConfirmStateLabFun(params.value)
            }, width: 90
          },
          {
            headerName: this.$t('WriteOff.type'), field: 'isReceivable',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }, width: 70
          },
          { headerName: this.$t('WriteOff.currency'), field: 'currency', width: 70 },
          {
            headerName: this.$t('WriteOff.writeOffExchangeRate'), field: 'writeoffRate',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 8), 8)
            }, width: 90
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'), field: 'exchangeRate',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 8), 8)
            }, width: 90
          },
          {
            headerName: this.$t('WriteOff.amount'), field: 'amount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2), 2)
            }, width: 110
          },
          {
            headerName: this.$t('WriteOff.lastTimeBalance'), field: 'lastTimeRemainAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2), 2)
            }, width: 110
          },
          {
            headerName: this.$t('WriteOff.thisTimeWriteOff'), field: 'currentVerifiedAmount', width: 120,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: true,
              tag: 'el-input-number',
              precision: 2,
              valueChanged: p => {
                this.onCellChange(p)
              }
            }
          },
          {
            headerName: this.$t('WriteOff.thisTimeBalance'), field: 'currentRemainAmount', width: 120,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: true,
              tag: 'el-input-number',
              precision: 2,
              valueChanged: p => {
                this.onCellChange(p)
              }
            }
          },
          {
            headerName: this.$t('WriteOff.businessStatus'), field: 'jobState',
            valueFormatter: (params) => {
              return ColumnUtils.jobStateLabelFunc(params.value)
            }, width: 110
          }
        ],
        rowData: []
      },
      actualPaymentDialog: {
        visible: false
      },
      once: new Once(this),
      subtotalGroup: [], // 小计

      isAr: false,
      totalVerifyAmount: 0, // 可销金额总计/本次核销
      totalAmount: 0, // 总金额/上次余额
      totalRemainAmount: 0, // 总余额/本次余额

      rateBy: 'average', // 销账汇率: invoice/average
      // lbOtherCurrency1: 'USD', //
      txtOtherRate1: 0, //
      // lbOtherCurrency2: 'EUR', //
      txtOtherRate2: 0, //

      // nsEnableWriteoffAmount: 0, // 上次余额
      // nsCurrentWriteoffAmount: 0, // 本次核销
      // nsCurrentWriteoffBalance: 0, // 本次余额

      // ddlReceiveType: 2,
      // ddlCashTransferState: 0, // 水单状态
      // ddlOurBank: '', // 我方银行
      // txtOurBankAccount: '', // 我方账号
      // ourBankCurrency: '', // 我方账号币种
      // ourBankAccountId: null,
      // txtVoucherNo: '', // 凭证号

      writeoffCurrency: 'RMB', // 币种
      nsActualAmount: 0, // 收款金额

      // txtPayCompany: '', // 对方单位
      // txtPayBank: '', // 对方银行
      // txtPayAccountNo: '', // 对方账号

      nsDiffChange: undefined, // 汇兑损益
      nsFinancialCost: undefined, // 财务费用
      nsClearOdd: undefined, // 零头短账
      txtRemark: '', // 销账备注
      dfAmountDate: moment().format('yyyy-MM-DD'), // 收付日期
      bankAccounts: null, // 销账银行账号
      useReceiptRecord: false, // 是否点击收款记录
      ticketNoEditDisable: false,
      cbConfirmedCharge: false, // 是否确认费用
      reCalc: true, // 折合重算
      selectedRow: {}, // 当前选中行
      selectedRowMode: 0, // 当前选中行类型
      selectedRowHedge: false,
      showRecordButton: true,
      realSendReceiveDialog: {
        visible: false,
        params: null,
        dialogClickRow: null, // 新增实收实付中选中的行
        useMultipleRecords: false, // 是否使用多个实收记录
        selectedRows: [] //
      },
      hasTotalVerifyAmount: false, // 是否勾选算本次核销金额
      executing: false, // 执行中
      actualAmountGrid: {
        gridOptions: {
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        gridParams: {},
        gridApi: {},
        rowData: []
      },
      writeOffModel: new WriteOffModel().fillDefaultValue().getData(), // 销账实体
      preExchangeDifference: 0, // 预估汇差
      preExchangeDiffRateMap: {},
      isFinanceChargeShareJob: false, // 财务费用是否分摊到业务
      financeChargeShareDialog: {
        visible: false,
        receivable: false,
        currency: '',
        exchangeRate: 0,
        amount: 0,
        confirmCallback: () => {},
        cancelCallback: () => {},
        returnData: null
      },
      isFullWriteOff: false, // 是否完成核销了费用
      localAmountSum: 0,
      whtCurrency: '',
      whtAmount: 0,
      rateUpdateModel: [], // rate需要根据【收/付款日期】刷新的model
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      showMarkOrCargoEnglishNameDialog: false // 英文品名唛头是否双击展示
    }
  },
  computed: {
    paramsFinal() {
      const defaultParams = {
        mode: 0,
        writeOffMode: 1
      }
      return Object.assign(defaultParams, this.params)
    },
    url() {
      return URL
    },
    // 基础数据
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    lbOtherCurrency1() {
      if (this.properties && this.properties.otherCurrencyRate.length > 0) {
        return this.properties.otherCurrencyRate[0]['currency']
      }
      return ''
    },
    txtOtherRate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.lbOtherCurrency1)
    },
    // txtOtherRate1() {
    //   if (this.properties && this.properties.otherCurrencyRate.length > 0) {
    //     return NumberUtils.roundHalfUp(this.properties.otherCurrencyRate[0]['rate'], 6)
    //   }
    //   return 0
    // },
    lbOtherCurrency2() {
      if (this.properties && this.properties.otherCurrencyRate.length > 1) {
        return this.properties.otherCurrencyRate[1]['currency']
      }
      return ''
    },
    txtOtherRate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.lbOtherCurrency2)
    },
    // txtOtherRate2() {
    //   if (this.properties && this.properties.otherCurrencyRate.length > 1) {
    //     return NumberUtils.roundHalfUp(this.properties.otherCurrencyRate[1]['rate'], 6)
    //   }
    //   return 0
    // },
    lbArAlert() {
      let text = ''
      if (this.properties && this.properties.isHedge) {
        text = this.$t('WriteOff.receivables')
        text += this.isAr ? ' > ' : ' < '
        text += this.$t('WriteOff.payables')
      }
      return text
    },
    arLabel() {
      return this.isAr ? this.$t('CargoMsg.Cargo_Receipt') : this.$t('CargoMsg.Cargo_Payment')
    },
    classType() {
      switch (this.properties.writeOffMode) {
        case 1:
          return 'charge'
          break
        case 2:
          return 'invoice'
          break
        case 3:
          return 'billing'
          break
        case 4:
          return 'billingGroup'
          break
        case 5:
          return 'billPayment'
          break
        default:
          return ''
      }
    },
    hedgeType() {
      if (!this.properties.isHedge) return ''
      switch (this.properties.writeOffModeHedge) {
        case 1:
          return 'charge'
          break
        case 2:
          return 'invoice'
          break
        case 3:
          return 'billing'
          break
        case 4:
          return 'billingGroup'
          break
        case 5:
          return 'billPayment'
          break
        default:
          return ''
      }
    },
    currencyTotal() {
      return this.writeoffCurrency
    },
    dgChargeRowData() {
      if (this.selectedRowMode === 0) {
        return this.properties.allEntities
      } else {
        const self = this
        return this.properties.allEntities.filter(function(elem) {
          // 结算单位
          if (self.selectedRowMode === 1) {
            if (!self.properties.isHedge) {
              return (elem.accountId === self.selectedRow.accountId)
            } else {
              return (elem.accountId === self.selectedRow.accountId && elem.isHedge === self.selectedRowHedge)
            }
          } else {
            switch (self.selectedRowMode) {
              case 1:
                break
              case 2:
                return (elem.invoiceUuid === self.selectedRow.uuid)
                break
              case 3:
                return (elem.billingUuid === self.selectedRow.uuid)
                break
              case 4:
                return (elem.billingGroupUuid === self.selectedRow.uuid)
                break
              case 5:
                return (elem.billPaymentUuid === self.selectedRow.uuid)
                break
            }
          }
        })
      }
    },
    rateByInvoice() {
      switch (this.properties.writeOffMode) {
        case 1:
          return ''
          break
        case 2:
          return this.$t('CargoMsg.Cargo_ByInvoiceFxRate')
          break
        case 3:
          return this.$t('CargoMsg.Cargo_AccordingBillExchangeRate')
          break
        case 4:
          return this.$t('CargoMsg.Cargo_AccordingForStatementFxRate')
          break
        case 5:
          return this.$t('CargoMsg.Cargo_ByPaymentRequestFxRate')
          break
        default:
          return this.$t('CargoMsg.Cargo_ByInvoiceFxRate')
      }
    },
    useActualAmountRecordLabel() {
      if (!this.useReceiptRecord) {
        return this.isAr ? this.$t('WriteOff.useReceiptRecord') : this.$t('WriteOff.usePaymentRecord')
      } else {
        return this.isAr ? this.$t('WriteOff.cancelUsedReceiptRecord') : this.$t('WriteOff.cancelUsedPaymentRecord')
      }
    },
    isExecuting() {
      return this.executing
    },
    actualAmountColumnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('WriteOff.ourSideBank'), field: 'ourBankAccountId', colId: 'ourBankAccountId', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: this.bankAccounts,
              filterable: true,
              tagValue: 'accountId',
              tagName: 'bankChineseName',
              customLabel: (item) => `[${item.code}][${item.currency}][${item.bankChineseName}]`,
              showCustomLabelInOption: true,
              cache: false,
              filterTagNames: ['bankChineseName', 'bankEnglishName', 'code', 'currency', 'shortName'],
              filterType: 'global'
            }
          },
          valueFormatter: (params) => {
            return this.ourBankLabelFunc(params.value)
          },
          onCellValueChanged: p => this.onActualAmountCellChange(p)
        },
        {
          headerName: this.$t('WriteOff.ourSideAccount'), field: 'ourBankAccount', colId: 'ourBankAccount', width: 140, editable: false,
          valueFormatter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('WriteOff.currency'), field: 'writeoffCurrency', colId: 'writeoffCurrency', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              staticOptions: ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency),
              tagValue: 'code',
              tagName: 'code',
              filterable: true,
              clearable: false
            }
          },
          onCellValueChanged: p => this.onActualAmountCellChange(p)
        },
        {
          headerName: this.isAr ? this.$t('WriteOff.paymentMethod') : this.$t('WriteOff.methodOfPayment'),
          field: 'receiveType', colId: 'receiveType', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES,
              tagValue: 'code',
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              clearable: false,
              filterable: true,
              filterType: 'global'
            }
          },
          valueFormatter: (params) => {
            return ColumnUtils.receiveTypeFunc(params.value)
          },
          onCellValueChanged: p => this.onActualAmountCellChange(p)
        },
        {
          headerName: this.$t('WriteOff.bankReceiptStatus'), field: 'cashTransferState', colId: 'cashTransferState', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.local_cache_ClearingConstants$CASH_TRANSFER_STATES,
              tagValue: 'code',
              clearable: false,
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              filterable: true,
              filterType: 'global'
            }
          },
          valueFormatter: (params) => {
            return ColumnUtils.cashTransferStateFunc(params.value)
          }
        },
        {
          headerName: this.$t('WriteOff.settleAccountsTo'), field: 'account', colId: 'account', width: 200, editable: false,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('WriteOff.theOppositeSideCompany'), field: 'payCompany', colId: 'payCompany', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('WriteOff.theOppositeSideBank'), field: 'payBank', colId: 'payBank', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('WriteOff.theOppositeSideAccount'), field: 'payAccountNo', colId: 'payAccountNo', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('WriteOff.proofNo'), field: 'voucherNo', colId: 'voucherNo', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('WriteOff.bankWaterNo'), field: 'bankWaterNo', colId: 'bankWaterNo', width: 180,
          editable: !this.useReceiptRecord,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('Payment.ticketNo'),
          colId: 'ticketNo',
          width: 180,
          field: 'ticketNo',
          editable: !this.useReceiptRecord && this.ticketNoEditDisable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          hide: true
        }
      ]
      return columnDefs
    },
    // 查询收款记录：结算对象
    searchAccountId() {
      if (this.properties.writeoffByDifferentAccount) {
        return 0
      } else {
        return this.properties.accountId
      }
    },
    showWhtTax() {
      return this.$store.getters.currentOffice.whtTaxMode
    },
    // REQ-0009: 销账抬头下拉框始终显示，不再受「多抬头银行模式」开关限制。
    // 注意：银行↔抬头联动(BankUtil / bringDefaultOurBankAccount / 水单反查)仍各自保留 multiTitleBankMode 守卫，
    // 未开多抬头模式的分公司选抬头不影响我方银行。
    showWriteOffHeader() {
      return true
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.isFinanceChargeShareJob = false
        this.rateUpdateModel = []
      }
    },
    nsFinancialCost(newVal) {
      if (!newVal) {
        this.isFinanceChargeShareJob = false
      }
    },
    useReceiptRecord(newVal) {
      if (newVal) {
        this.isFinanceChargeShareJob = false
      }
    }
  },
  async created() {
    // this.dgCharge.columnDefs = [
    //   {
    //     headerName: '', width: 55, checkboxSelection: true, pinned: 'left',
    //     sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
    //     headerCheckboxSelection: true
    //   },
    //   { headerName: '业务编号', field: '', width: 200 },
    //   { headerName: 'MBL', field: '', width: 200 },
    //   { headerName: '业务日期', field: '', width: 200 },
    //   { headerName: '费用名称', field: '', width: 200 },
    //   { headerName: '对账状态', field: '', width: 200 },
    //   { headerName: '类型', field: '', width: 200 },
    //   { headerName: '市种', field: '', width: 200 },
    //   { headerName: '核销汇率', field: '', width: 200 },
    //   { headerName: '金额', field: '', width: 200 },
    //   { headerName: '上次余额', field: '', width: 200 },
    //   { headerName: '本次核销', field: '', width: 200 },
    //   { headerName: '本次余额', field: '', width: 200 }
    // ]
    this.isInputZeroFee = parseInt(cache.config.get('InputZeroFee')) === 1
    this.dgGroup.columnDefs = this.getDynamicLeftColumnDefs(this.properties.writeOffMode)
    if (this.properties.isHedge) {
      this.dgHedge.columnDefs = this.getDynamicLeftColumnDefs(this.properties.writeOffModeHedge)
    }
    //
    this.selectedRow = this.properties.selectedEntities[0]
    this.selectedRowMode = this.properties.writeOffMode
    this.selectedRowHedge = false
    // 收付日期
    this.dfAmountDate = this.properties.rpDate
    this.isFinanceChargeShareJob = false
  },
  async mounted() {
    this.$nextTick(() => {
      this.resetMargin()
    })
    await this.changedDefaultCurrency()
    // await this.getBankAccounts()

    // 获取发票抬头列表
    await this.getInvoiceTitlesByOfficeCache.execute({ officeId: this.$store.getters.currentOfficeId }).then(async res => {
      this.ourInvoiceTitleArray = res.data
      // 带默认抬头
      // REQ-0009: 所有分公司都自动带默认抬头(若有 isDefault)，不再要求开启多抬头银行模式。
      if (this.ourInvoiceTitleArray && this.ourInvoiceTitleArray.length > 0) {
        const tilteObj = this.ourInvoiceTitleArray.find(p => !!p.isDefault)
        if (tilteObj) {
          this.actualAmountTitle = tilteObj.invoiceTitle
        }
      }
      // 获取银行列表
      await this.getBankAccountListCache.execute(this.$store.getters.currentOfficeUuid).then(res => {
        this.allOurBankAccountArray = res.data
        this.initOurBankAccountArray()
      })
    })
    this.actualAmountGrid.rowData = []
    this.writeOffModel = new WriteOffModel().fillDefaultValue().getData()
    this.writeOffModel.writeoffCurrency = this.writeoffCurrency // 销账币种
    this.writeOffModel.ourBank = '' // 我方银行
    this.writeOffModel.cashTransferState = 0 // 水单状态
    this.writeOffModel.ourBankAccountId = 0 // 我方银行ID(虚拟字段，用来定位具体的我放银行)
    this.writeOffModel.receiveType = 2 // 收款方式: 银行转账
    // CARGO-8057，销账时对方单位以及对方账号能够自动带出
    this.writeOffModel.payCompany = this.properties.allEntities[0].paymentCompany
    this.writeOffModel.payBank = this.properties.allEntities[0].companyBank
    this.writeOffModel.payAccountNo = this.properties.allEntities[0].companyBankAccount
    this.actualAmountGrid.rowData.push(this.writeOffModel)
    this.bringDefaultOurBankAccount(this.writeOffModel)
    // 水单默认使用付款申请
    if ((this.properties.bankSlip || this.viewSource === 'tabNonWriteOffList') && this.properties.actualAmount) {
      this.useReceiptRecord = true
      this.initOurBankAccountArray()
      await this.fillViewByActualAmount()
    }
    let jobUuid = ''
    for (const charge of this.properties.entities) {
      if (!this.whtCurrency) {
        this.whtCurrency = charge.localCurrency
      }
      if (charge.localAmount) {
        this.localAmountSum += charge.localAmount || 0
      } else {
        const amount = new BigNumber(charge.amount)
        const exchangeRate = new BigNumber(charge.exchangeRate)
        this.localAmountSum += NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(amount, exchangeRate), charge.localCurrency), 2)
      }
      this.whtAmount += charge.whtTaxLocalAmount || 0
      if (!jobUuid) {
        jobUuid = charge.jobUuid
      }
    }
    if (this.properties.isHedge && this.properties.hedgeEntities.length > 0) {
      for (const charge of this.properties.hedgeEntities) {
        if (!this.whtCurrency) {
          this.whtCurrency = charge.localCurrency
        }
        if (charge.localAmount) {
          this.localAmountSum += charge.localAmount || 0
        } else {
          const amount = new BigNumber(charge.amount)
          const exchangeRate = new BigNumber(charge.exchangeRate)
          this.localAmountSum += NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(amount, exchangeRate), charge.localCurrency), 2)
        }
        this.whtAmount += charge.whtTaxLocalAmount || 0
        if (!jobUuid) {
          jobUuid = charge.jobUuid
        }
      }
    }
    if (!this.whtCurrency) {
      this.whtCurrency = 'RMB'
    }
    this.localAmountSum = NumberUtils.ToFixed2(this.localAmountSum, 2)
    this.whtAmount = NumberUtils.ToFixed2(this.whtAmount, 2)
    this.checkFullWriteOff()
    if ((!this.properties.actualAmount || !this.properties.actualAmount.uuid) && !this.txtRemark && this.isAr) {
      if (this.properties.kartenNumberRule) {
        generateSeqNoByKartenNumberRule({ jobUuid }).then(res => {
          this.txtRemark = res.data.seqNo
        })
      } else {
        this.refreshTxtRemarks()
      }
    }
  },
  methods: {
    // 初始化 我方银行下拉
    initOurBankAccountArray() {
      if (this.useReceiptRecord) {
        this.bankAccounts = this.allOurBankAccountArray
      } else {
        this.bankAccounts = BankUtils.initOurBankAccountArray(this, this.allOurBankAccountArray, this.ourInvoiceTitleArray, this.actualAmountTitle)
      }
    },
    // 带出 默认我方银行
    bringDefaultOurBankAccount(data) {
      //  未使用付款记录（单条实收实付）
      if (!this.useReceiptRecord) {
        if (this.$store.getters.currentOffice.multiTitleBankMode) {
          // 多抬头模式
          const currency = data.writeoffCurrency || this.writeoffCurrency || 'RMB'
          const targetBank = BankUtils.bringDefaultOurBankAccount(this, this.bankAccounts, this.ourInvoiceTitleArray, this.actualAmountTitle, currency)
          if (targetBank && targetBank.accountNo) {
            data.ourBank = targetBank.bankChineseName
            data.ourBankAccount = targetBank.accountNo
            data.ourBankCurrency = targetBank.currency
            data.ourBankAccountId = targetBank.accountId
          } else {
            // 兜底：没有设置默认付款账号时，取第一条匹配币种的银行
            const fallbackBank = this.getCurrencyBankAccount(currency, false)
            if (fallbackBank) {
              data.ourBank = fallbackBank.bankChineseName
              data.ourBankAccount = fallbackBank.accountNo
              data.ourBankCurrency = fallbackBank.currency
              data.ourBankAccountId = fallbackBank.accountId
            }
          }
          if (this.actualAmountGrid.gridApi) {
            this.actualAmountGrid.gridApi.refreshCells({ force: true })
          }
        } else {
          // 非 多抬头模式
          let bankAccount = this.getCurrencyBankAccount(this.writeoffCurrency, true)
          if (bankAccount === null) {
            bankAccount = this.getCurrencyBankAccount(this.writeoffCurrency, false)
          }
          if (bankAccount !== null && !this.useReceiptRecord) {
            data.ourBankAccount = bankAccount.accountNo
            data.ourBank = bankAccount.bankChineseName
            data.ourBankCurrency = bankAccount.currency
            data.ourBankAccountId = bankAccount.accountId
          }
        }
      }
    },
    actualAmountTitleChangeEvent(p) {
      if (p) {
        this.actualAmountTitle = p.value
      } else {
        this.actualAmountTitle = ''
      }
      this.initOurBankAccountArray()
      this.bringDefaultOurBankAccount(this.writeOffModel)
    },
    resetMargin() {
      const screen1366Width = 1366 / window.devicePixelRatio // 适配1366*768分辨率的屏幕宽度(px)
      const offsetPx = window.screen.width - screen1366Width // 与当前屏幕的偏移量
      // 大于1366*768分辨率的屏幕（直接返回，不做处理），10为误差值；
      if (offsetPx > 10) {
        return
      }
      const clientHeight15 = document.body.clientHeight * 0.15
      let marginTop = clientHeight15 - 70
      if (marginTop < 0) {
        marginTop = 0
      }
      /* 嵌入样式 */
      const head = document.head || document.getElementsByTagName('head')[0]
      const textContent = `.write-off-dialog-margin{margin-top:${marginTop}px !important}`
      let isExist = false
      for (const childNode of head.childNodes) {
        if (childNode.textContent.includes('.write-off-dialog-margin')) {
          childNode.textContent = textContent
          isExist = true
          break
        }
      }
      if (!isExist) {
        this.appendStyle(textContent)
      }
    },
    appendStyle(textContent) {
      const head = document.head || document.getElementsByTagName('head')[0]
      const style = document.createElement('style')
      if (style.styleSheet) { // IE
        if (style.styleSheet.disabled) {
          setTimeout(() => {
            style.styleSheet.cssText = textContent
          }, 10)
        } else {
          style.styleSheet.cssText = textContent
        }
      } else { // w3c
        style.appendChild(document.createTextNode(textContent))
      }
      head.appendChild(style)
    },
    setDgChareColumnDefs(api) {
      const detailsColumnDef = this.dgCharge.gridOptions.detailCellRendererParams.detailGridOptions.columnDefs
      const { rowsToDisplay } = api.getModel()
      if (rowsToDisplay.length > rowsToDisplay.filter(row => row.level === 0).length) {
        api.setColumnDefs(this.dgCharge.columnDefs.filter(column => {
          return !detailsColumnDef.find(detailColumn => detailColumn.field === column.field)
        }))
      } else {
        api.setColumnDefs([...this.dgCharge.columnDefs, ...detailsColumnDef.filter(detailColumn => {
          return !this.dgCharge.columnDefs.find(column => detailColumn.field === column.field)
        })])
      }
    },
    getDynamicLeftColumnDefs(writeOffMode) {
      const expandColumnDef = {
        headerName: '',
        field: '',
        pinned: 'right',
        width: this.expandColumnDefWidth(writeOffMode),
        cellRenderer: (params) => {
          return this.dgCharge.show
            ? '<span style="display: flex; justify-content: center;font-weight: bold;font-size:16px">>></span>'
            : '<span style="display: flex; justify-content: center;font-weight: bold;font-size:16px"><<</span>'
        },
        onCellClicked: (params) => {
          const cell = this.dgGroup.gridOptions.api.getFocusedCell()
          this.dgCharge.show = !this.dgCharge.show
          if (this.dgCharge.show) {
            this.setSelected()
          }
          let leftGridTopColumnDefs = this.getDynamicLeftColumnDefs(this.properties.writeOffMode)
          if (this.dgCharge.show) {
            const result = []
            result.push(leftGridTopColumnDefs.shift(), leftGridTopColumnDefs.pop())
            leftGridTopColumnDefs = result
          }
          // this.dgGroup.gridOptions.api.setColumnDefs(leftGridTopColumnDefs)
          // this.dgGroup.gridOptions.api.redrawRows()
          this.dgGroup.columnDefs = leftGridTopColumnDefs
          if (cell) {
            setTimeout(() => {
              this.dgGroup.gridOptions.api.setFocusedCell(cell.rowIndex, this.dgGroup.gridOptions.api.columnController.getAllDisplayedColumns()[0])
            }, 100)
          }
          if (this.properties.isHedge) {
            let leftGridBottomColumnDefs = this.getDynamicLeftColumnDefs(this.properties.writeOffModeHedge)
            const cellHedge = this.dgHedge.gridOptions.api.getFocusedCell()
            if (this.dgCharge.show) {
              const result = []
              result.push(leftGridBottomColumnDefs.shift(), leftGridBottomColumnDefs.pop())
              leftGridBottomColumnDefs = result
            }
            // this.dgHedge.gridOptions.api.setColumnDefs(leftGridBottomColumnDefs)
            // this.dgHedge.gridOptions.api.redrawRows()
            this.dgHedge.columnDefs = leftGridBottomColumnDefs
            if (cellHedge) {
              setTimeout(() => {
                this.dgHedge.gridOptions.api.setFocusedCell(cellHedge.rowIndex, this.dgHedge.gridOptions.api.columnController.getAllDisplayedColumns()[0])
              }, 100)
            }
          }
        }
      }
      const chargeColumnDefs = [
        {
          headerName: this.$t('WriteOff.settleAccountsTo'), field: 'accountId',
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, width: this.dgCharge.show ? 170 : 800
        }
      ]
      const invoiceColumnDefs = [
        { headerName: this.$t('WriteOff.invoiceNo'), field: 'invoiceNo', width: 120 },
        { headerName: this.$t('WriteOff.invoiceHeader'), field: 'title', width: 180 },
        {
          headerName: this.$t('WriteOff.settlementCompany'), field: 'accountId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, width: 180
        },
        {
          headerName: this.$t('WriteOff.invoiceDate'), field: 'invoiceDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120
        },
        { headerName: this.$t('WriteOff.currency'), field: 'currency', width: 120 },
        {
          headerName: this.$t('WriteOff.amount'), field: 'amount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2), 2)
          }, width: 120
        },
        {
          headerName: this.$t('WriteOff.revenueAndExpenditureType'), field: 'isAr',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }, width: 120
        }
      ]
      const billingColumnDefs = [
        { headerName: this.$t('WriteOff.billNo'), field: 'billingNo', width: 120 },
        // { headerName: this.$t('WriteOff.settlementCompany'), field: 'accountId',
        //   cellRenderer: (params) => {
        //     return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        //   }, width: 180 },
        { headerName: this.$t('WriteOff.currency'), field: 'currency', width: 120 },
        {
          headerName: this.$t('WriteOff.amount'), field: 'amount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2), 2)
          }, width: 120
        },
        {
          headerName: 'ETD', field: 'jobEtd',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120
        }
      ]
      const billingGroupColumnDefs = [
        { headerName: this.$t('WriteOff.accountStatementNo'), field: 'billingNo', width: 120 },
        {
          headerName: this.$t('WriteOff.settleAccountsTo'), field: 'accountId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, width: 180
        },
        { headerName: this.$t('WriteOff.billType'), field: 'billingType', width: 120 },
        { headerName: this.$t('WriteOff.invoiceHeader'), field: 'title', width: 180 },
        { headerName: this.$t('WriteOff.currency'), field: 'currency', width: 120 },
        {
          headerName: this.$t('WriteOff.amount'), field: 'amount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2), 2)
          }, width: 120
        }
      ]
      const billPaymentColumnDefs = [
        { headerName: this.$t('WriteOff.applicationNo'), field: 'billPaymentNo', width: 120 },
        {
          headerName: this.$t('WriteOff.settleAccountsTo'), field: 'accountId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, width: 180
        },
        {
          headerName: this.$t('WriteOff.settlementAgent'), field: 'settlementAgentId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, width: 180
        },
        {
          headerName: this.$t('WriteOff.applicant'), field: 'inputBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 120
        },
        { headerName: this.$t('WriteOff.theOppositeSideInvoiceNo'), field: 'costInvoiceNo', width: 120 },
        { headerName: this.$t('WriteOff.currency'), field: 'currency', width: 120 }
      ]
      let columnDefs = []
      switch (writeOffMode) {
        case 1:
          columnDefs = chargeColumnDefs
          break
        case 2:
          columnDefs = invoiceColumnDefs
          break
        case 3:
          columnDefs = billingColumnDefs
          break
        case 4:
          columnDefs = billingGroupColumnDefs
          break
        case 5:
          columnDefs = billPaymentColumnDefs
          break
      }
      columnDefs.push(expandColumnDef)
      return columnDefs
    },
    expandColumnDefWidth(writeOffMode) {
      let width = 80
      switch (writeOffMode) {
        case 1:
          if (this.dgCharge.show) {
            width = 53
          } else {
            width = 327
          }
          break
        case 2:
          if (this.dgCharge.show) {
            width = 103
          } else {
            width = 167
          }
          break
        case 3:
          if (this.dgCharge.show) {
            width = 103
          } else {
            width = 647
          }
          break
        case 4:
          if (this.dgCharge.show) {
            width = 103
          } else {
            width = 287
          }
          break
        case 5:
          if (this.dgCharge.show) {
            width = 103
          } else {
            width = 287
          }
          break
      }
      return width
    },
    // 使用收款记录
    useActualAmountRecordHandler() {
      if (this.useReceiptRecord) {
        this.cancelUseActualAmountRecordHandler()
      } else {
        this.realSendReceiveDialog.dialogClickRow = null
        this.realSendReceiveDialog.visible = true
      }
    },
    // 取消使用收款记录
    cancelUseActualAmountRecordHandler() {
      this.properties.actualAmount = {}
      this.properties.actualAmounts = {}
      this.useReceiptRecord = false
      this.initOurBankAccountArray()
      if (this.realSendReceiveDialog.useMultipleRecords) {
        const actualAmountRowData = this.actualAmountGrid.rowData
        if (actualAmountRowData.length > 1) {
          const writeOffModel = actualAmountRowData[0]
          this.actualAmountGrid.rowData = []
          this.actualAmountGrid.rowData.push(writeOffModel)
          this.realSendReceiveDialog.useMultipleRecords = false
        }
      }
      for (const item of this.actualAmountGrid.rowData) {
        item.account = ''
      }
      this.fillViewByActualAmount()
    },
    selectedActualPayment(data) {
    },
    cancel() {
      this.$emit('update:visible', false)
      if (this.destroySelf) {
        this.destroySelf()
      }
    },

    onGridReady_dgGroup(params) {
      this.dgGroup.gridApi = params.api
    },
    onGridReady_dgHedge(params) {
      this.dgHedge.gridApi = params.api
    },
    onGridReady_dgCharge(params) {
      this.dgCharge.gridApi = params.api
      // 全选
      this.dgCharge.gridApi.selectAll()
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid: lodash.debounce(function() {
      this.refreshSelectedCountChargeGrid()
      this.checkFullWriteOff()
    }, 200, {
      trailing: true
    }),
    refreshSelectedCountChargeGrid() {
      this.subtotalGroup = []
      this.subtotalGroup = this.getGridSelectedRows(true) // getGridSelected(this.dgCharge.gridOptions)
      //
      this.calcTotalVerifyAmount()
      this.calcPreExchangeDifference()
    },
    // 选择币种
    async currencyChangeEvent(value) {
      this.writeoffCurrency = value.value
      await this.refreshWriteoffRate()
      if (this.rateBy === 'invoice' || this.rateBy === 'charge') {
        this.rateByChangeHandler(this.rateBy)
      } else {
        this.calcTotalVerifyAmount()
      }
    },
    // 费用全部是同一个币种，则核销币种就用这个币种，否则按照目前流程默认RMB的方式处理
    async changedDefaultCurrency() {
      let invoiceCurrency = ''
      switch (this.properties.writeOffMode) {
        case 1:
          break
        case 2:
          if (this.properties.writeOffMode.isWriteoffCurrencyByInvoice) {
            invoiceCurrency = this.properties.selectedEntities[0].currency
          }
          break
        case 3:
        case 4:
        case 5:
          invoiceCurrency = this.properties.selectedEntities[0].currency
          break
      }
      // CARGO-3899，销账时按不同的销账模式带出默认的销账币种、金额、汇率
      if (!StrUtils.isEmpty(invoiceCurrency)) {
        this.properties.defaultCurrency = invoiceCurrency
      } else {
        if (this.properties.currencys.length === 1) {
          this.properties.defaultCurrency = this.properties.allEntities[0].currency
        }
      }
      if (this.properties.actualAmount && this.properties.actualAmount.currency && this.properties.actualAmount.bankSlip) {
        this.properties.defaultCurrency = this.properties.actualAmount.currency
      }
      this.writeoffCurrency = this.properties.defaultCurrency
      await this.refreshWriteoffRate()
      // CARGO-7631，针对发票，根据参数isWriteoffCurrencyByInvoice，当按发票币种时（=1），默认勾选“按发票汇率”
      if (this.properties.isWriteoffCurrencyByInvoice && this.properties.writeOffMode === 2) {
        this.rateBy = 'invoice'
        // this.$refs.dgWriteoff.rateByChangeHandler()
        await this.rateByChangeHandler(this.rateBy)
      } else {
        this.calcTotalVerifyAmount()
      }

      // if(_actualAmount && formActualAmount)
      // {
      //   formActualAmount.actualAmountVO = _actualAmount
      // }
      // formActualAmount.useReceiptRecord = false
    },
    // CARGO-7631, 按发票、按账单等核销时，取发票、账单本身汇率
    async rateByChangeHandler(value) {
      this.rateBy = value
      switch (this.rateBy) {
        case 'invoice':
          this.setOtherCurrencyRateByInovice()
          this.calcTotalVerifyAmount()
          break
        case 'average':
          await this.refreshWriteoffRate()
          this.calcTotalVerifyAmount()
          break
        case 'charge':
          this.setOtherCurrencyRateByCharge()
          this.calcTotalVerifyAmount()
          break
        default:
          break
      }
    },
    // 刷新核销汇率
    async refreshWriteoffRate() {
      await this.refreshOtherCurrency()
      this.updateChargeRates()
    },
    // 刷新其它币种信息
    async refreshOtherCurrency() {
      const currencys = []
      for (const currency of this.properties.currencys) {
        if (currency !== this.writeoffCurrency && currencys.indexOf(currency) === -1) {
          currencys.push(currency)
        }
      }
      this.properties.otherCurrencyRate = []
      for (const currency of currencys) {
        // CARGO-3899，销账时按不同的销账模式带出默认的销账币种、金额、汇率
        let rate = 0
        if (this.properties.entities.length > 0) {
          switch (this.properties.writeOffMode) {
            case 1:
              break
            case 2: // 发票
              rate = await this.getInvoiceAverageRate(this.writeoffCurrency, currency)
              break
            case 3: // 账单
              rate = await this.getBillingAverageRate(this.writeoffCurrency, currency)
              break
            case 4: // 对账单
              rate = await this.getBillingGroupAverageRate(this.writeoffCurrency, currency)
              break
            case 5: // 付款申请
              rate = await this.getBillPaymentAverageRate(this.writeoffCurrency, currency)
              break
          }
        }
        if (rate === 0) {
          // CARGO-10449，使用收款记录，汇率应更新成所选择的实收付记录的月份对应的汇率
          if (this.properties.actualAmount && !StrUtils.isEmpty(this.properties.actualAmount.payReceiveDate)) {
            rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, currency, this.properties.actualAmount.payReceiveDate, this.properties.actualAmount.branchId)
          } else {
            rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, currency, this.dfAmountDate, 0)
          }
        }
        this.properties.otherCurrencyRate.push({ 'currency': currency, 'rate': rate })
      }
      //
      this.refreshOtherCurrencyRate()
    },
    refreshOtherCurrencyRate() {
      this.txtOtherRate1 = undefined
      if (this.properties && this.properties.otherCurrencyRate.length > 0) {
        this.txtOtherRate1 = NumberUtils.roundHalfUp(this.properties.otherCurrencyRate[0]['rate'], 8)
        if (this.txtOtherRate1 === 0) this.txtOtherRate1 = undefined
      }
      this.txtOtherRate2 = undefined
      if (this.properties && this.properties.otherCurrencyRate.length > 1) {
        this.txtOtherRate2 = NumberUtils.roundHalfUp(this.properties.otherCurrencyRate[1]['rate'], 8)
        if (this.txtOtherRate2 === 0) this.txtOtherRate2 = undefined
      }
    },
    // 更新费用汇率
    updateChargeRates() {
      for (const charge of this.properties.allEntities) {
        if (charge.currency === this.writeoffCurrency) {
          charge.writeoffRate = 1
        } else {
          for (const item of this.properties.otherCurrencyRate) {
            if (item['currency'] === charge.currency && this.rateBy !== 'charge') {
              charge.writeoffRate = NumberUtils.roundHalfUp(item['rate'], 8)
              break
            }
          }
        }
      }
      // 小计
      this.subtotalGroup = []
      this.subtotalGroup = this.getGridSelectedRows() // getGridSelected(this.dgCharge.gridOptions)
      // 刷新
      this.$nextTick(() => {
        this.dgCharge.gridOptions.api.refreshCells({ force: true })
      })
    },
    // 修改其它币种汇率
    setOtherCurrencyRate(currency, rate) {
      for (const item of this.properties.otherCurrencyRate) {
        if (item['currency'] === currency) {
          item['rate'] = rate
          this.updateChargeRates()
          break
        }
      }
    },
    // 修改其它币种汇率 - 按发票/账单/对账单/付款申请汇率
    async setOtherCurrencyRateByInovice() {
      if (this.properties.allEntities.length === 0) {
        return
      }
      for (const charge of this.properties.allEntities) {
        if (charge.currency === this.writeoffCurrency) {
          charge.writeoffRate = 1
        } else {
          let rate = 0
          switch (this.properties.writeOffMode) {
            case 1:
              break
            case 2: // 发票
              if (charge.invoiceCurrency === this.writeoffCurrency) {
                if (charge.invoiceChargeCurrency1 === charge.currency) {
                  rate = charge.invoiceChargeExchangeRate1
                } else if (charge.invoiceChargeCurrency2 === charge.currency) {
                  rate = charge.invoiceChargeExchangeRate2
                }
              }
              break
            case 3: // 账单
              if (charge.billingCurrency === this.writeoffCurrency) {
                if (charge.billingSourceCurrency1 === charge.currency) {
                  rate = charge.billingSourceRate1
                } else if (charge.billingSourceCurrency2 === charge.currency) {
                  rate = charge.billingSourceRate2
                } else if (charge.billingSourceCurrency3 === charge.currency) {
                  rate = charge.billingSourceRate3
                }
              }
              break
            case 4: // 对账单
              if (charge.billingGroupCurrency === this.writeoffCurrency) {
                rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, charge.currency, charge.billingGroupInputDate, 0)
              }
              break
            case 5: // 付款申请
              // CARGO-39011 付款申请支持多币种
              if (charge.billPaymentCurrency === this.writeoffCurrency) {
                if ((charge.currency1 || charge.currency2 || charge.currency3) && !charge.rateByCharge) {
                  if (charge.currency1 === charge.currency) {
                    rate = charge.rate1
                  } else if (charge.currency2 === charge.currency) {
                    rate = charge.rate2
                  } else if (charge.currency3 === charge.currency) {
                    rate = charge.rate3
                  } else {
                    rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, charge.currency, charge.billPaymentDateModified, 0)
                  }
                } else {
                  if (charge.billPaymentOtherCurrency === charge.currency) {
                    rate = charge.billPaymentRate
                  } else {
                    rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, charge.currency, charge.billPaymentDateModified, 0)
                  }
                }
              }
              break
          }
          if (rate === 0) {
            if (this.properties.actualAmount && !StrUtils.isEmpty(this.properties.actualAmount.payReceiveDate)) {
              rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, charge.currency, this.properties.actualAmount.payReceiveDate, this.properties.actualAmount.branchId)
            } else {
              rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, charge.currency, this.dfAmountDate, 0)
            }
          }
          charge.writeoffRate = rate
        }
      }
      // 刷新
      this.$nextTick(() => {
        this.dgCharge.gridOptions.api.refreshCells({ force: true })
      })
    },
    // 获取发票列表中其它费用的对应汇率
    getInvoiceAverageRate(currency, otherCurrency) {
      let rate = 0
      let invoiceRate = 0 // 发票汇率
      let localAmount = 0 // 本币金额
      let amount = 0 // 原币金额
      for (const charge of this.properties.entities) {
        invoiceRate = 0
        if (charge.invoiceCurrency === currency) {
          if (charge.invoiceChargeCurrency1 === otherCurrency) {
            invoiceRate = charge.invoiceChargeExchangeRate1
          } else if (charge.invoiceChargeCurrency2 === otherCurrency) {
            invoiceRate = charge.invoiceChargeExchangeRate2
          }
        }
        if (invoiceRate !== 0) {
          // 各发票的本币金额、原币金额
          if (charge.currency === otherCurrency) {
            if (charge.isReceivable) {
              amount += charge.amount
              // localAmount += charge.amount * invoiceRate
              localAmount += RateUtil.getAmountByCurrency(charge.amount * invoiceRate, currency)
            } else {
              amount -= charge.amount
              // localAmount -= charge.amount * invoiceRate
              localAmount -= RateUtil.getAmountByCurrency(charge.amount * invoiceRate, currency)
            }
          }
        }
      }
      if (localAmount !== 0 && amount !== 0) {
        rate = CurrencyUtil.roundHalfUpRateByCurrency(currency, localAmount / amount)
      }
      return rate
    },
    // 获取账单列表中其它费用的对应汇率
    getBillingAverageRate(currency, otherCurrency) {
      let rate = 0
      let billingRate = 0 // 账单汇率
      let localAmount = 0 // 本币金额
      let amount = 0 // 原币金额
      for (const charge of this.properties.entities) {
        billingRate = 0
        if (charge.billingCurrency === currency) {
          if (charge.billingSourceCurrency1 === otherCurrency) {
            billingRate = charge.billingSourceRate1
          } else if (charge.billingSourceCurrency2 === otherCurrency) {
            billingRate = charge.billingSourceRate2
          } else if (charge.billingSourceCurrency3 === otherCurrency) {
            billingRate = charge.billingSourceRate3
          }
        }
        if (billingRate !== 0) {
          // 各账单的本币金额、原币金额
          if (charge.currency === otherCurrency) {
            if (charge.isReceivable) {
              amount += charge.amount
              // localAmount += charge.amount * billingRate
              localAmount += RateUtil.getAmountByCurrency(charge.amount * billingRate, currency)
            } else {
              amount -= charge.amount
              // localAmount -= charge.amount * billingRate
              localAmount -= RateUtil.getAmountByCurrency(charge.amount * billingRate, currency)
            }
          }
        }
      }
      if (localAmount !== 0 && amount !== 0) {
        rate = CurrencyUtil.roundHalfUpRateByCurrency(currency, localAmount / amount)
      }
      return rate
    },
    // 获取对账单列表中其它费用的对应汇率
    async getBillingGroupAverageRate(currency, otherCurrency) {
      let rate = 0
      let billingRate = 0 // 对账单汇率
      let localAmount = 0 // 本币金额
      let amount = 0 // 原币金额
      for (const charge of this.properties.entities) {
        billingRate = 0
        // 对账单，没有记录币种汇率。创建时，根据制单日期inputDate。
        // 参照 BillingGroupService.calculateAmount
        if (charge.billingGroupCurrency === currency) {
          billingRate = await RateUtil.getForeignExchangeRateSafely(currency, otherCurrency, charge.billingGroupInputDate, 0)
        }
        if (billingRate !== 0) {
          // 各对账单的本币金额、原币金额
          if (charge.currency === otherCurrency) {
            if (charge.isReceivable) {
              amount += charge.amount
              // localAmount += charge.amount * billingRate
              localAmount += RateUtil.getAmountByCurrency(charge.amount * billingRate, currency)
            } else {
              amount -= charge.amount
              // localAmount -= charge.amount * billingRate
              localAmount -= RateUtil.getAmountByCurrency(charge.amount * billingRate, currency)
            }
          }
        }
      }
      if (localAmount !== 0 && amount !== 0) {
        rate = CurrencyUtil.roundHalfUpRateByCurrency(currency, localAmount / amount)
      }
      return rate
    },
    // 获取付款申请列表中其它费用的对应汇率
    async getBillPaymentAverageRate(currency, otherCurrency) {
      let rate = 0
      let billingRate = 0 // 付款申请汇率
      let localAmount = 0 // 本币金额
      let amount = 0 // 原币金额
      for (const charge of this.properties.entities) {
        billingRate = 0
        if (charge.billPaymentCurrency === currency) {
          // 付款申请，只记录了一个币种汇率，且没记录币种，默认取币种分组第一个；其他的，新增/修改，都按当前日期 new Date()
          // 其它汇率，参照BillPaymentForm.currencyChangeHandler
          if (charge.billPaymentOtherCurrency === otherCurrency) {
            billingRate = charge.billPaymentRate
          } else { // 参照BillPaymentForm.refreshAmount
            billingRate = await RateUtil.getForeignExchangeRateSafely(currency, otherCurrency, charge.billPaymentDateModified, 0)
          }
        }
        if (billingRate !== 0) {
          // 各付款申请的本币金额、原币金额
          if (charge.currency === otherCurrency) {
            if (charge.isReceivable) {
              amount += charge.amount
              // localAmount += charge.amount * billingRate
              localAmount += RateUtil.getAmountByCurrency(charge.amount * billingRate, currency)
            } else {
              amount -= charge.amount
              // localAmount -= charge.amount * billingRate
              localAmount -= RateUtil.getAmountByCurrency(charge.amount * billingRate, currency)
            }
          }
        }
      }
      if (localAmount !== 0 && amount !== 0) {
        rate = CurrencyUtil.roundHalfUpRateByCurrency(currency, localAmount / amount)
      }
      return rate
    },

    // 计算可销余额总值
    calcTotalVerifyAmount() {
      if (this.properties.allEntities.length === 0) {
        return
      }
      this.totalVerifyAmount = 0
      this.totalAmount = 0
      this.totalRemainAmount = 0
      this.hasTotalVerifyAmount = false
      // 识别收付的标识
      let sign = 1
      let rate = 1
      let arCount = 0
      let apCount = 0
      // 可销金额总计
      const charges = this.getGridSelectedRows() // getGridSelected(this.dgCharge.gridOptions)
      // 此处将各个币种分别相加 判断是否为0
      const currencyMap = {}
      for (const charge of charges) {
        sign = charge.isReceivable ? 1 : -1
        let amount = 0.0
        if (currencyMap[charge.currency]) {
          amount = currencyMap[charge.currency]
        }
        amount += NumberUtils.roundHalfUp(charge.currentVerifiedAmount * sign)
        currencyMap[charge.currency] = amount
      }
      // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 本次核销金额
      const totalVerifyAmountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.properties.allEntities, 'currency', 'currentVerifiedAmount', 'isReceivable')
      for (const charge of charges) {
        this.hasTotalVerifyAmount = true
        sign = charge.isReceivable ? 1 : -1
        rate = 1
        if (this.writeoffCurrency !== charge.currency) {
          rate = charge.writeoffRate
        }
        if (totalVerifyAmountCurrencys.includes(charge.currency)) continue
        if (currencyMap && currencyMap[charge.currency] !== 0) {
          // this.totalVerifyAmount += NumberUtils.roundHalfUp(rate * charge.currentVerifiedAmount * sign)
          // this.totalVerifyAmount = NumberUtils.roundHalfUp(this.totalVerifyAmount)
          this.totalVerifyAmount += NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(rate * charge.currentVerifiedAmount * sign, this.writeoffCurrency))
          this.totalVerifyAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.totalVerifyAmount, this.writeoffCurrency))
        }
        if (charge.isReceivable) {
          arCount++
        } else {
          apCount++
        }
      }
      // 此处将各个币种分别相加 判断是否为0
      const currency2Map = {}
      for (const charge of this.properties.allEntities) {
        sign = charge.isReceivable ? 1 : -1
        let amount = 0.0
        if (currency2Map[charge.currency]) {
          amount = currency2Map[charge.currency]
        }
        amount += NumberUtils.roundHalfUp(charge.currentVerifiedAmount * sign)
        currency2Map[charge.currency] = amount
      }
      //  CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 总金额、总余额
      const totalRemainAmountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.properties.allEntities, 'currency', 'currentRemainAmount', 'isReceivable')
      const totalAmountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.properties.allEntities, 'currency', 'lastTimeRemainAmount', 'isReceivable')
      // 总金额、总余额
      for (const charge of this.properties.allEntities) {
        sign = charge.isReceivable ? 1 : -1
        rate = 1
        if (this.writeoffCurrency !== charge.currency) {
          rate = charge.writeoffRate
        }
        if (currency2Map && currency2Map[charge.currency]) {
          // this.totalRemainAmount += NumberUtils.roundHalfUp(rate * charge.currentRemainAmount * sign)
          // this.totalAmount += NumberUtils.roundHalfUp(rate * charge.lastTimeRemainAmount * sign)
          if (!totalRemainAmountCurrencys.includes(charge.currency)) {
            this.totalRemainAmount += NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(rate * charge.currentRemainAmount * sign, this.writeoffCurrency))
          }
          if (!totalAmountCurrencys.includes(charge.currency)) {
            this.totalAmount += NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(rate * charge.lastTimeRemainAmount * sign, this.writeoffCurrency))
          }
        }
        // this.totalAmount = NumberUtils.roundHalfUp(this.totalAmount)
        // this.totalRemainAmount = NumberUtils.roundHalfUp(this.totalRemainAmount)
        this.totalAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.totalAmount, this.writeoffCurrency))
        this.totalRemainAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.totalRemainAmount, this.writeoffCurrency))
      }
      this.isAr = (this.totalVerifyAmount > 0 || (this.totalVerifyAmount === 0 && arCount >= apCount))
      this.totalVerifyAmount = Math.abs(NumberUtils.roundHalfUp(this.totalVerifyAmount))
      this.totalAmount = Math.abs(NumberUtils.roundHalfUp(this.totalAmount))
      this.totalRemainAmount = Math.abs(NumberUtils.roundHalfUp(this.totalRemainAmount))
      //
      if (!this.hasTotalVerifyAmount && this.totalVerifyAmount === 0) this.totalVerifyAmount = undefined
      if (!this.hasTotalVerifyAmount && this.totalRemainAmount === 0 && this.totalAmount === 0) this.totalRemainAmount = undefined
      if (!this.hasTotalVerifyAmount && this.totalAmount === 0) this.totalAmount = undefined
      this.verifyAmountChanged()
      // 折合重算
      setTimeout(() => {
        this.reCalc = false
      }, 100)
      setTimeout(() => {
        this.reCalc = true
      }, 100)
    },
    async verifyAmountChanged() {
      if (StrUtils.isEmpty(this.totalVerifyAmount)) this.totalVerifyAmount = 0
      this.nsActualAmount = this.totalVerifyAmount
      let modelRemainAmount = this.totalVerifyAmount

      if (!this.realSendReceiveDialog.useMultipleRecords) {
        if (this.properties.actualAmount && this.properties.actualAmount.currency && this.properties.actualAmount.currency !== this.writeoffCurrency) {
          const rate = await RateUtil.getForeignExchangeRateSafely(this.properties.actualAmount.currency, this.writeoffCurrency, StrUtils.isEmpty(this.properties.actualAmount.payReceiveDate) ? new Date() : this.properties.actualAmount.payReceiveDate, this.properties.actualAmount.branchId)
          modelRemainAmount = rate * this.totalVerifyAmount
        }
        if (this.properties.actualAmount && modelRemainAmount > this.properties.actualAmount.remainAmount) {
          this.$confirm(this.arLabel + this.$t('CargoMsg.Cargo_InsufficientRecordBalance') + NumberUtils.formatNumber(this.totalVerifyAmount, 2), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }).then(() => {
            //
          }).catch(() => {
            //
          })
        }
      } else {
        let totalRemainAmount = 0.00
        const currency = this.properties.actualAmounts[0].currency
        const payReceiveDate = StrUtils.isEmpty(this.properties.actualAmounts[0].payReceiveDate) ? new Date() : this.properties.actualAmounts[0].payReceiveDate
        if (currency !== this.writeoffCurrency) {
          const rate = await RateUtil.getForeignExchangeRateSafely(currency, this.writeoffCurrency, payReceiveDate, this.properties.actualAmounts[0].branchId)
          modelRemainAmount = rate * this.totalVerifyAmount
        }
        for (const item of this.properties.actualAmounts) {
          totalRemainAmount = totalRemainAmount + item.remainAmount
        }
        if (this.properties.actualAmounts && modelRemainAmount > totalRemainAmount) {
          this.$confirm(this.arLabel + this.$t('CargoMsg.Cargo_InsufficientRecordBalance') + NumberUtils.formatNumber(this.totalVerifyAmount, 2), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }).then(() => {
            //
          }).catch(() => {
            //
          })
        }
      }
      this.calcBalance()
    },
    // 收款金额
    async nsActualAmountChangeHandler(value) {
      this.nsActualAmount = value
      if (this.rateBy === 'average' && this.useReceiptRecord && ((this.properties.actualAmount) && this.properties.actualAmount.uuid) ||
          this.properties.actualAmounts && this.properties.actualAmounts.length > 0) {
        let remainAmount = 0.0
        if (!this.realSendReceiveDialog.useMultipleRecords) {
          const actualAmount = this.properties.actualAmount
          remainAmount = actualAmount.remainAmount
        } else {
          for (const item of this.properties.actualAmounts) {
            remainAmount = remainAmount + item.remainAmount
          }
        }
        if (this.nsActualAmount > remainAmount) {
          this.$confirm(this.arLabel + this.$t('CargoMsg.Cargo_InsufficientRecordBalance') + NumberUtils.formatNumber(this.nsActualAmount, 2), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }).then(() => {
          }).catch(() => {
          })
        }
      }
      this.calcBalance()
    },
    calcBalance() {
      if (StrUtils.isEmpty(this.nsActualAmount)) this.nsActualAmount = 0
      if (StrUtils.isEmpty(this.totalVerifyAmount)) this.totalVerifyAmount = 0
      this.nsClearOdd = -(this.nsActualAmount - this.totalVerifyAmount)
      if (this.nsActualAmount === 0) this.nsActualAmount = undefined
      if (!this.hasTotalVerifyAmount && this.totalVerifyAmount === 0) this.totalVerifyAmount = undefined
      if (this.nsClearOdd === 0) this.nsClearOdd = undefined
    },
    // 收款日期
    async dfAmountDateChangeHandler(value) {
      this.dfAmountDate = value
      if (this.rateUpdateModel.length > 0) {
        const localCurrency = RateUtil.localCurrencyByOffice()
        for (const model of this.rateUpdateModel) {
          model.rate = RateUtil.getForeignExchangeRateSafely(localCurrency, model.currency, StrUtils.isEmpty(this.dfAmountDate) ? new Date() : this.dfAmountDate, 0)
        }
      }
      await this.refreshWriteoffRate()
      if (this.rateBy === 'invoice') {
        this.rateByChangeHandler(this.rateBy)
      } else {
        // CARGO-6752，对冲销账金额存在差异。重选收付款日期，本次核销未重算
        this.calcTotalVerifyAmount()
      }
      this.$nextTick(() => {
        this.calcPreExchangeDifference()
        this.refreshTxtRemarks()
      })
    },
    // 确定销账
    async commitHandler() {
      this.loading = getLoading4Cxt(this.$refs.dialog)
      this.isLoading = true
      try {
        await sleep(500)
        if (this.isExecuting) {
          this.loading.close()
          return
        }
        if (this.properties && this.rateBy === 'average' && this.properties.otherCurrencyRate.length > 0) {
          if (this.properties.otherCurrencyRate.length > 0) {
            const rate = NumberUtils.roundHalfUp(this.properties.otherCurrencyRate[0]['rate'], 8)
            if (rate === 0) {
              this.loading.close()
              this.$message.warning(this.$t('WriteOff.noCurrencyRate').format(this.properties.otherCurrencyRate[0]['currency']))
              this.isLoading = false
              return
            }
          }
          if (this.properties.otherCurrencyRate.length > 1) {
            const rate1 = NumberUtils.roundHalfUp(this.properties.otherCurrencyRate[1]['rate'], 8)
            if (rate1 === 0) {
              this.loading.close()
              this.$message.warning(this.$t('WriteOff.noCurrencyRate').format(this.properties.otherCurrencyRate[1]['currency']))
              this.isLoading = false
              return
            }
          }
        }
        if (!this.hasTotalVerifyAmount) {
          if (StrUtils.isEmpty(this.totalVerifyAmount) || this.totalVerifyAmount === 0) {
            this.loading.close()
            this.isLoading = false
            return
          }
        }
        if (!this.properties.isHedge && this.realSendReceiveDialog.useMultipleRecords && this.useReceiptRecord) {
          await this.writeOffByMultipleActualAmount()
        } else {
          let modelRemainAmount = this.totalVerifyAmount

          if (this.properties.actualAmount && this.properties.actualAmount.currency && this.properties.actualAmount.currency !== this.writeoffCurrency) {
            const rate = await RateUtil.getForeignExchangeRateSafely(this.properties.actualAmount.currency, this.writeoffCurrency, StrUtils.isEmpty(this.properties.actualAmount.payReceiveDate) ? new Date() : this.properties.actualAmount.payReceiveDate, this.properties.actualAmount.branchId)
            modelRemainAmount = rate * this.totalVerifyAmount
          }
          if (!this.dfAmountDate) {
            this.loading.close()
            this.isLoading = false
            this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.arLabel + this.$t('CargoMsg.Cargo_Date'))
            return
          }
          // else if (this.properties.actualAmount && this.properties.actualAmount.currency && this.properties.actualAmount.bankSlip) {
          //   this.$message.warning(this.$t('CargoMsg.Cargo_WORIPCPARO'))
          //   return
          // }
          else if (this.properties.mustUseActualAmountWriteoff && !(this.properties.actualAmount && this.properties.actualAmount.currency)) {
            this.loading.close()
            this.isLoading = false
            this.$message.warning(this.$t('CargoMsg.Cargo_PSROACP'))
            return
          } else if (this.properties.actualAmount && this.properties.actualAmount.currency && modelRemainAmount > this.properties.actualAmount.remainAmount) {
            this.loading.close()
            this.isLoading = false
            this.$message.warning(this.$t('CargoMsg.Cargo_InsufficientRecordBalance') + this.totalVerifyAmount)
            return
          } else if (this.properties.actualAmount && this.properties.actualAmount.currency && this.properties.actualAmount.bankSlip && this.properties.actualAmount.remainAmount < this.totalVerifyAmount) {
            this.loading.close()
            this.isLoading = false
            this.$message.warning(this.$t('CargoMsg.Cargo_BOPIOOPCTBLTCWOA'))
            return
          } else {
            const writeoffCharge = this.getGridSelectedRows() // getGridSelected(this.dgCharge.gridOptions)
            if (writeoffCharge.length === 0) {
              this.loading.close()
              this.isLoading = false
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToWriteOff'))
              return
            }
          }

          let count = 0
          if (this.properties.currencys.indexOf(this.writeoffCurrency) !== -1) {
            count = this.properties.currencys.length
          } else {
            count = this.properties.currencys.length + 1
          }
          if (count > 3) {
            this.loading.close()
            this.isLoading = false
            this.$message.warning(this.$t('CargoMsg.Cargo_NMT2MCTAIEAWO'))
            return
          }

          // if (this.properties.writeoffCheckBillpaymentDone) {
          //   if ((this.properties.entities.length > 0 && this.classType !== 'billPayment' && !this.checkBillPayment(this.properties.entities)) ||
          //       (this.properties.isHedge && this.properties.hedgeEntities.length > 0 && this.hedgeType !== 'billPayment' && !this.checkBillPayment(this.properties.hedgeEntities))) {
          //     this.loading.close()
          //     this.isLoading = false
          //     this.$message.warning(this.$t('CargoMsg.Cargo_OFAOPOTFSIITPRPPDNOATRIC'))
          //     return
          //   }
          // }
          // CARGO-897，销账银行账号与销账币种不匹配
          let isSameCurrency = true
          const txtOurBankAccount = this.actualAmountGrid.rowData[0].ourBankAccount
          if (!StrUtils.isEmpty(this.writeoffCurrency) && !StrUtils.isEmpty(txtOurBankAccount)) {
            if (this.bankAccounts !== null) {
              isSameCurrency = false
              for (const bankAccount of this.bankAccounts) {
                if (!StrUtils.isEmpty(bankAccount.currency) && this.writeoffCurrency === bankAccount.currency && !StrUtils.isEmpty(bankAccount.accountNo) && txtOurBankAccount === bankAccount.accountNo) {
                  isSameCurrency = true // 币种相同
                  break
                }
              }
            }
          }
          if (!isSameCurrency) {
            await this.$confirm(this.$t('CargoMsg.Cargo_TSBADNCTCC'), this.$t('CargoMsg.Cargo_Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
              type: 'warning'
            }).then(async() => {
              await this.writeOffConfirm()
            }).catch(() => {
            }).finally(() => {
              this.loading.close()
              this.isLoading = false
            })
          } else {
            await this.writeOffConfirm()
          }
        }
      } finally {
        if (!this.isExecuting) {
          this.isLoading = false
          this.loading.close()
        }
      }
    },
    checkBillPayment(charges) {
      let pass = true
      for (const charge of charges) {
        if (Math.abs(charge.currentVerifiedAmount) >= 0.005 && !charge.isPaidOff && !StrUtils.isEmpty(charge.billPaymentUuid) && charge.billPaymentState < 3) {
          pass = false
          break
        }
      }
      return pass
    },
    async writeOffConfirm() {
      await sleep(500)
      const actualAmount = StrUtils.isEmpty(this.nsActualAmount) ? 0 : this.nsActualAmount
      const writeOffAmount = this.totalVerifyAmount
      const diffChange = StrUtils.isEmpty(this.nsDiffChange) ? 0 : this.nsDiffChange
      const financialCost = StrUtils.isEmpty(this.nsFinancialCost) ? 0 : this.nsFinancialCost
      const clearOdd = StrUtils.isEmpty(this.nsClearOdd) ? 0 : this.nsClearOdd
      let isDiffBranchData = false
      for (const c of this.properties.allEntities) {
        if (!SecurityUtil.checkChargeBranch(c.branchId)) {
          isDiffBranchData = true
          break
        }
      }
      if (isDiffBranchData && !this.properties.allowWriteOffDiffBranch) {
        this.loading.close()
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        this.isLoading = false
        return
      }
      let needBlock = false
      for (const item of this.properties.allEntities) {
        // 若费用的报价确认为否
        if (item.chargeBusinessQuotationAmount > 0 && !item.chargeBusinessQuotationConfirmd) {
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId)
          this.$message.warning(this.$t('CargoMsg.Cargo_UnconfirmedSum', [item.jobNo, chargeItem.zhName, item.currency, item.amount]))
          needBlock = true
          break
        }
      }
      if (needBlock) {
        this.isLoading = false
        return
      }
      if (isDiffBranchData) {
        await this.$confirm(this.$t('CargoMsg.Cargo_TDCBODNBTTCBOTULBC'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(async() => {
          await this.confirmWriteOff(writeOffAmount, actualAmount, diffChange, financialCost, clearOdd)
        }).catch(() => {
        }).finally(() => {
          this.loading.close()
          this.isLoading = false
        })
      } else {
        await this.confirmWriteOff(writeOffAmount, actualAmount, diffChange, financialCost, clearOdd)
      }
    },
    async confirmWriteOff(writeOffAmount, actualAmount, diffChange, financialCost, clearOdd) {
      if (Math.abs(writeOffAmount - (actualAmount + diffChange + (this.isFinanceChargeShareJob ? 0 : financialCost) + clearOdd)) > 0.01) {
        this.$message.warning(this.arLabel + (this.isFinanceChargeShareJob ? this.$t('CargoMsg.Cargo_TAOPLFESAMBETCWOANoFinance') : this.$t('CargoMsg.Cargo_TAOPLFESAMBETCWOA')))
        this.loading.close()
        this.isLoading = false
        return
      }
      if (this.isFinanceChargeShareJob) {
        try {
          this.financeChargeShareDialog.returnData = await this.showFinanceChargeShareDialog(financialCost)
        } catch {
          this.loading.close()
          this.isLoading = false
          return
        }
      }
      const messages = []
      const h = this.$createElement
      const label = this.isAr ? this.$t('CargoMsg.Cargo_FinancialReceived') : this.$t('CargoMsg.Cargo_RealPaid')
      messages.push(h('p', null, this.$t('CargoMsg.Cargo_PCAOCO').format(label) + NumberUtils.formatNumber(actualAmount, 2)))
      messages.push(h('p', null, this.$t('CargoMsg.Cargo_WriteOffAmountIs') + NumberUtils.formatNumber(writeOffAmount, 2)))
      messages.push(h('p', null, this.$t('CargoMsg.Cargo_ConsolidatedProfitLossIs') + NumberUtils.formatNumber(diffChange, 2)))
      messages.push(h('p', null, this.$t('CargoMsg.Cargo_FinancialExpenseIs') + NumberUtils.formatNumber(financialCost, 2)))
      messages.push(h('p', null, this.$t('CargoMsg.Cargo_ShortAccountIs') + NumberUtils.formatNumber(clearOdd, 2)))
      await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmWriteOff'), {
        title: this.$t('CargoMsg.Cargo_ConfirmWriteOff'),
        message: h('div', null, messages),
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        closeOnClickModal: false,
        type: 'info'
      }).then(async() => {
        if (this.realSendReceiveDialog.useMultipleRecords && this.useReceiptRecord) {
          await this.doWriteOffByByMultipleActualAmountHandler()
        } else {
          await this.doWriteOffHandler()
        }
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
        this.isLoading = false
      })
    },
    async showFinanceChargeShareDialog(financialCost) {
      let resolveRef
      let rejectRef
      const dialogResut = new Promise((resolve, reject) => {
        resolveRef = resolve
        rejectRef = reject
      })
      this.financeChargeShareDialog.confirmCallback = p => {
        resolveRef(p)
      }
      this.financeChargeShareDialog.cancelCallback = () => {
        rejectRef()
      }
      this.financeChargeShareDialog.receivable = this.isAr
      this.financeChargeShareDialog.currency = this.writeoffCurrency
      if (!(this.properties.actualAmount && this.properties.actualAmount.currency)) {
        const localCurrency = RateUtil.localCurrencyByOffice()
        this.financeChargeShareDialog.exchangeRate = RateUtil.getForeignExchangeRateSafely(localCurrency, this.writeoffCurrency, new Date(), 0)
      } else {
        const model = this.properties.actualAmount
        if (model.verificationBy === 0 && model.rate === 0) {
          const localCurrency = RateUtil.localCurrencyByOfficeId(model.branchId)
          this.financeChargeShareDialog.exchangeRate = RateUtil.getForeignExchangeRateSafely(localCurrency, this.writeoffCurrency, new Date(), model.branchId)
        } else {
          this.financeChargeShareDialog.exchangeRate = model.rate
        }
      }
      this.financeChargeShareDialog.amount = financialCost
      this.financeChargeShareDialog.visible = true
      return dialogResut
    },
    // 放单提醒弹窗
    // async manualTriggerAndUpateFunc() {
    //   const dataList = []
    //   this.properties.selectedEntitiesOrigin.map((item) => {
    //     if (this.properties.writeOffMode === 1) {
    //       dataList.push(item.jobUuid)
    //     } else {
    //       dataList.push(item.uuid)
    //     }
    //   })

    //   const params = {
    //     dataList: dataList,
    //     officeId: this.$store.getters.currentOfficeId,
    //     state: this.properties.writeOffMode
    //   }
    //   writeOffManualTriggerAndUpate(params).then((res) => {
    //     if (res.ok) {
    //       console.log(res.data)
    //     }
    //   })
    // },
    async doWriteOffHandler() {
      let model = this.properties.actualAmount
      if (!this.nsActualAmount) {
        this.nsActualAmount = 0
      }
      const modelFinancialCost = this.isFinanceChargeShareJob ? 0 : this.nsFinancialCost
      if (!(this.properties.actualAmount && this.properties.actualAmount.currency)) {
        model = await this.createModel()
        model.amount = this.nsActualAmount
        model.verfiedAmount = model.amount
        model.remainAmount = 0
        model.clearOdd = this.nsClearOdd
        model.diffChange = this.nsDiffChange
        model.financialCost = modelFinancialCost
        model.preExchangeDifference = this.preExchangeDifference
      } else {
        if (model.verificationBy === 0) {
          if (model.rate === 0) {
            const localCurrency = RateUtil.localCurrencyByOfficeId(model.branchId)
            model.rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, model.currency, StrUtils.isEmpty(model.payReceiveDate) ? new Date() : model.payReceiveDate, model.branchId)
            this.rateUpdateModel.push(model)
          }
          model.verificationBy = this.$store.getters.userId
          model.verificationByDep = this.$store.getters.currentDeptId
          model.verificationDate = new Date()
        }
        model.remainAmount = NumberUtils.roundHalfUp(model.remainAmount - this.nsActualAmount)
        if (model.remainAmount !== 0) {
          model.verfiedAmount = model.amount - model.remainAmount
        }
        if (model.verfiedAmount === 0 && !model.bankSlip) {
          model.verfiedAmount = model.amount
        }
        model.clearOdd += this.nsClearOdd
        model.diffChange += this.nsDiffChange
        model.financialCost += modelFinancialCost
        model.preExchangeDifference += this.preExchangeDifference
      }
      const map = {}
      const writeoffCharges = []
      const hedgeCharges = []
      const classType = this.classType
      const hedgeType = this.hedgeType
      let isArIncluded = this.properties.isEntitiesAr
      let isApIncluded = !this.properties.isEntitiesAr
      this.checkWriteoffCharges(this.properties.entities, writeoffCharges, map)
      if (writeoffCharges.length === 0) {
        this.$confirm(this.$t('CargoMsg.Cargo_ExpenseWriteOffCanTBeEmpty'), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).finally(() => {
          this.loading.close()
          this.isLoading = false
        })
        return
      }
      if (this.properties.isHedge && this.properties.hedgeEntities.length > 0) {
        this.checkWriteoffCharges(this.properties.hedgeEntities, hedgeCharges, map)
        if (!isArIncluded) {
          isArIncluded = this.properties.isHedgeEntitiesAr
        }
        if (!isApIncluded) {
          isApIncluded = !this.properties.isHedgeEntitiesAr
        }
      }
      model.arIncluded = isArIncluded
      model.apIncluded = isApIncluded
      // 多结算单位进行销账，生成的实收实付单中accountId等于0（此时弹出窗口名称固定为“销账”）
      if (this.$t('CargoMsg.Cargo_WriteOff') === this.title) {
        if (this.properties.writeoffByDifferentAccount) {
          if (!ClearingUtils.isSameAccount(this.properties.entities)) {
            model.accountId = 0
          } else {
            if (!model.uuid) model.accountId = (this.properties.accountId === 0) ? this.properties.entities[0].accountId : this.properties.accountId
          }
        } else {
          if (model.accountId === 0) {
            model.accountId = (this.properties.accountId === 0) ? this.properties.entities[0].accountId : this.properties.accountId
          }
        }
      } else {
        if (this.$t('CargoMsg.Cargo_OverseasWriteOff') === this.title && this.properties.writeoffByDifferentAccount && !ClearingUtils.isSameAccount(this.properties.entities)) {
          model.accountId = 0
        } else {
          if (model.accountId === 0) {
            model.accountId = (this.properties.accountId === 0) ? this.properties.entities[0].accountId : this.properties.accountId
          }
        }
      }
      // CARGO-36084 重新判断是否存在多个结算对象
      if (this.properties.writeoffByDifferentAccount && model.accountId === 0 && this.properties.allEntities.size > 0) {
        model.accountId = this.properties.allEntities[0].accountId
        for (const c of this.properties.allEntities) {
          if (Math.abs(c.currentVerifiedAmount) >= 0.005 && !c.isPaidOff) {
            if (model.accountId !== 0 && model.accountId !== c.accountId) {
              model.accountId = 0
              break
            }
          }
        }
      }
      // CARGO-31043 判断结算代理是否一致
      if (!ClearingUtils.isSameSettlementAgent(this.properties.entities)) {
        model.settlementAgentId = 0
      } else {
        model.settlementAgentId = (!this.properties.settlementAgentId || this.properties.settlementAgentId === 0) ? this.properties.entities[0].settlementAgentId : this.properties.settlementAgentId
      }
      model.actualAmountTitle = this.actualAmountTitle
      if (this.properties.kartenNumberRule || this.properties.writeOffRemarkShowSrialNo) {
        model.remark = this.txtRemark
      }
      // 本次收/付金额+汇总损益+财务费用+零头短账，与本次核销金额校对
      map['actualAmount'] = this.nsActualAmount
      map['clearOdd'] = this.nsClearOdd
      map['diffChange'] = this.nsDiffChange
      map['financialCost'] = modelFinancialCost
      if (this.isExecuting) return
      this.executing = true
      try {
        const dataList = []
        this.properties.selectedEntitiesOrigin.map((item) => {
          if (this.properties.writeOffMode === 1) {
            dataList.push(item.jobUuid)
          } else {
            dataList.push(item.uuid)
          }
        })
        if (this.isFinanceChargeShareJob && this.financeChargeShareDialog.returnData) {
          map['financeCostShare'] = await this.generateChargeInfo(this.financeChargeShareDialog.returnData)
        }
        const requestBody = {
          'chargeKeys': writeoffCharges,
          'hedgeChargeKeys': hedgeCharges,
          'writeoffType': classType,
          'hedgeType': hedgeType,
          'actModel': model,
          'clearAmountMap': map,
          'currentOfficeId': this.$store.getters.currentOfficeId,
          dataList: dataList,
          state: this.properties.writeOffMode
        }
        if (!this.loading) {
          this.loading = getLoading()
        }
        requestBody.location = this.location
        await chargeWriteoff(requestBody).then(res => {
        // if (this.properties.selectedEntitiesOrigin.length > 0) {
        //   this.manualTriggerAndUpateFunc() // 执行手动放单
        // }
        // CW 核销记录推送金蝶
          if (!this.properties.isHedge && this.properties.openHecConfig) {
            const requestBody = {
              'actualAmountUuid': res.data['actualAmountUuid']
            }
            pushWriteOffSap(requestBody).then(res => {
              if (res.data.message === '1') {
                this.$message.success(this.$t('Message.WriteOffPushSuccess'))
                this.chargeWriteoffSuccess(res)
              } else {
                this.$message.error(this.$t('Message.WriteOffPushError'))
                // 推送失败则撤销销账
                requestBody.location = this.location
                writeoffApi.rollbackChargeWriteoff(requestBody).then(res => {}).catch(err => {})
              }
            }).finally(() => {
            })
          } else {
            this.chargeWriteoffSuccess(res)
          }
        })
      } finally {
        this.executing = false
        this.isLoading = false
        this.loading.close()
      }
    },
    // 生成费用信息
    async generateChargeInfo(data) {
      const obj = { ...data, financialCost: this.nsFinancialCost }
      const ajaxResults = []
      if (obj.accountId > 0) {
        // 设置开票抬头
        ajaxResults.push(ChargeUtils.updateDefaultInvoiceTitle([obj]))
        // 默认的结算代理
        ajaxResults.push(this.getSettlementByCompanyId(obj))
      }
      obj.localCurrency = RateUtil.localCurrencyByOffice()
      obj.measure = this.getMeasureData()
      obj.branchId = this.$store.getters.currentOfficeId
      await Promise.all(ajaxResults)
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', obj.chargeItemId)
      if (chargeItem) {
        obj.chargeItemId = chargeItem.itemId
        obj.serviceType = chargeItem.serviceType
      }
      return obj
    },
    // 根据结算对象，获取结算代理
    async getSettlementByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
      const res = await getSettlementAgentsByCmpIdx(charge.accountId)
      let dbSettlementAgents = res.data
      if (!dbSettlementAgents) dbSettlementAgents = []
      if (chargeAccount) {
        const index = dbSettlementAgents.findIndex(p => p.uuid === chargeAccount.uuid)
        if (index < 0) {
          dbSettlementAgents.push(chargeAccount)
        }
      }
      charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
    },
    getMeasureData() {
      const l = getCacheListByKey(TYPE_NAMES.basic_data_ChargeUnit)
      let measure = ''
      let piaoCode = ''
      for (const item of l) {
        if (item && item.ifDefault && item.unit) {
          measure = item.code
        }
        if (item.chineseName === '票') {
          piaoCode = item.code
        }
      }
      return measure || piaoCode
    },
    chargeWriteoffSuccess(res) {
      this.properties.actualAmount = {} // 重置
      this.properties.actualAmounts = []
      // const actualAmount = res.data['actualAmount']
      // const actualAmountNo = actualAmount.actualAmountNo
      let actualAmountNo = res.data['actualAmountNo']
      const financeActualAmountNo = res.data['financeActualAmountNo']
      if (financeActualAmountNo) {
        actualAmountNo += ',' + financeActualAmountNo
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, this.$t('CargoMsg.Cargo_ThisWriteOffNoIs')),
          h('span', { style: 'margin: 0 10px;font-size:18px;color:#1F75D5' }, actualAmountNo)
        ])
      ])
      this.$confirm(content, this.$t('CargoMsg.Cargo_WrittenOffSuccessfully'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_CloseAndCopySerialNumber'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Close'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        distinguishCancelAndClose: true,
        customClass: 'message-box-width-450',
        type: 'success'
      }).then(() => {
        let input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', actualAmountNo)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
          this.$message.success(this.$t('SeaExport.CopySuccess'))
        }
        document.body.removeChild(input)
        input = null
        this.$emit('writeoffSuccessHandler', 'success')
        this.cancel()
      }).catch((action) => {
        if (action === 'cancel') {
          this.$emit('writeoffSuccessHandler', 'success')
        }
        this.cancel()
      })
    },
    // 创建一个新的实收实付对象
    async createModel() {
      const writeOffModel = this.actualAmountGrid.rowData[0]
      const aa = {}
      aa.state = 1
      aa.currency = this.writeoffCurrency
      aa.amount = this.nsActualAmount
      aa.remainAmount = 0
      const localCurrency = RateUtil.localCurrencyByOffice()
      // CARGO-38882, 销账要根据收付日期来取汇率
      aa.rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, aa.currency, StrUtils.isEmpty(this.dfAmountDate) ? new Date() : this.dfAmountDate, 0)
      this.rateUpdateModel.push(aa)
      aa.ar = this.isAr
      aa.paymentCompany = writeOffModel.payCompany
      aa.type = writeOffModel.receiveType
      aa.voucherNo = writeOffModel.voucherNo
      aa.bankWaterNo = writeOffModel.bankWaterNo
      aa.companyBank = writeOffModel.payBank
      aa.companyBankAccount = writeOffModel.payAccountNo
      aa.ourBank = writeOffModel.ourBank
      aa.ourBankAccount = writeOffModel.ourBankAccount
      aa.ourBankCurrency = writeOffModel.ourBankCurrency
      aa.cashTransferState = writeOffModel.cashTransferState
      aa.remark = this.txtRemark
      aa.actualAmountTitle = this.actualAmountTitle
      aa.payReceiveDate = this.dfAmountDate
      aa.verificationBy = this.$store.getters.userId
      aa.verificationByDep = this.$store.getters.currentDeptId
      aa.verificationDate = new Date()
      aa.branchId = this.$store.getters.currentOfficeId
      aa.clearOdd = 0
      aa.accountId = this.properties.accountId
      aa.oversea = this.properties.isOversea
      aa.preAmount = 0
      aa.preBankSlipState = 0
      aa.preBankSlipState = 0
      aa.prePayment = false
      aa.returnAmount = 0
      aa.settlementAgentId = 0
      return aa
    },
    // 确认销账费用
    checkWriteoffCharges(charges, writeoffCharges, map) {
      for (const cc of charges) {
        for (const c of this.properties.allEntities) {
          if (cc.uuid === c.uuid) {
            if ((Math.abs(c.currentVerifiedAmount) >= 0.005 || (this.isInputZeroFee && c.amount === 0)) && !c.isPaidOff) {
              writeoffCharges.push(c.uuid)
              const verifiedAmount = c.verifiedAmount + c.currentVerifiedAmount
              //  !!! important
              // 如果是海外对账销账的话，就不刷费用! Marco 2016-06-27 为了海外结算中心而改
              // 以前用isOversea来判断【海外结算中心】逻辑，现在用新参数。
              if (!this.properties.isHQWriteoffConfirm || !this.properties.isOversea) {
                map[c.uuid + '_verifiedAmount'] = verifiedAmount.toFixed(2)
              }
              map[c.uuid + '_currentVerifiedAmount'] = c.currentVerifiedAmount.toFixed(2)
              map[c.uuid + '_writeoffRate'] = c.writeoffRate.toFixed(8)
              map[c.uuid + '_version'] = c.version
              map[c.uuid + '_jobNo'] = c.jobNo
              if (verifiedAmount.toFixed(2) === c.amount.toFixed(2) && (!this.properties.isHQWriteoffConfirm || !this.properties.isOversea)) {
                map[c.uuid + '_isPaidOff'] = true
              }
              map[c.uuid + '_beforeRate'] = c.beforeRate.toFixed(8) // 当时汇率
              map[c.uuid + '_currentRate'] = c.currentRate.toFixed(8) // 当前汇率
            }
          }
        }
      }
    },
    // 销账银行账号
    async getBankAccounts() {
      this.bankAccounts = null
      await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
        this.bankAccounts = res.data
      })
    },
    // 列数据改变
    onCellChange(params) {
      const charge = params.data
      const field = params.field
      let value = StrUtils.isEmpty(params.value) ? 0 : params.value
      let preventDefault = false
      switch (field) {
        case 'currentVerifiedAmount':
          if (value * charge.amount < 0 || Math.abs(value) > Math.abs(charge.amount - charge.verifiedAmount)) {
            value = charge.amount - charge.verifiedAmount
            value = RateUtil.getAmountByCurrency(value, charge.currency)
            charge.currentVerifiedAmount = value
            preventDefault = true
            break
          }
          value = RateUtil.getAmountByCurrency(value, charge.currency)
          charge.currentVerifiedAmount = value
          // charge.currentRemainAmount = NumberUtils.roundHalfUp(charge.lastTimeRemainAmount - value, 2)
          charge.currentRemainAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.lastTimeRemainAmount - value, charge.currency), 2)
          this.checkFullWriteOff()
          break
        case 'currentRemainAmount':
          if (value * charge.amount < 0 || Math.abs(value) > Math.abs(charge.lastTimeRemainAmount - charge.currentVerifiedAmount)) {
            preventDefault = true
            break
          }
          value = RateUtil.getAmountByCurrency(value, charge.currency)
          charge.currentRemainAmount = value
          // charge.currentVerifiedAmount = NumberUtils.roundHalfUp(charge.lastTimeRemainAmount - value, 2)
          charge.currentVerifiedAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.lastTimeRemainAmount - value, charge.currency), 2)
          this.checkFullWriteOff()
          break
        default:
      }
      if (preventDefault) {
        for (const entity of this.properties.allEntities) {
          if (charge.uuid === entity.uuid) { // 重置
            entity.currentVerifiedAmount = charge.currentVerifiedAmount
            entity.currentRemainAmount = charge.currentRemainAmount
          }
        }
        this.dgCharge.gridApi.setRowData(this.dgChargeRowData)
      } else {
        this.dgCharge.gridApi.refreshCells({ force: true })
      }
      this.$emit('cellChange', params)
      // 勾选
      this.$nextTick(() => {
        this.dgCharge.gridApi.forEachNode(node => {
          if (node.data.uuid === charge.uuid || preventDefault) {
            if (charge.currentVerifiedAmount === 0) {
              node.setSelected(false)
            } else {
              node.setSelected(true)
            }
          }
        })
        //
        this.toRefreshSelectedCountChargeGrid()
      })
    },
    // 校验是否完全核销了费用
    checkFullWriteOff() {
      this.isFullWriteOff = true
      for (const charge of this.properties.allEntities) {
        if (NumberUtils.ToFixed2(charge.currentVerifiedAmount, 2) < NumberUtils.ToFixed2(charge.amount, 2)) {
          this.isFullWriteOff = false
          break
        }
      }
    },
    // 获取默认账号
    getCurrencyBankAccount(currency, isDefault = false) {
      let ba = null
      for (const bankAccount of this.bankAccounts) {
        if (currency === bankAccount.currency) {
          if (!isDefault) {
            ba = bankAccount
            break
          } else if (bankAccount.defaultPayment) {
            ba = bankAccount
            break
          }
        }
      }
      return ba
    },
    // 根据各种自动关联账号
    checkCurrencyBankAccount(data) {
      this.bringDefaultOurBankAccount(data)
      // let bankAccount = this.getCurrencyBankAccount(this.writeoffCurrency, true)
      // if (bankAccount === null) {
      //   bankAccount = this.getCurrencyBankAccount(this.writeoffCurrency, false)
      // }
      // if (bankAccount !== null && !this.useReceiptRecord) {
      //   data.ourBankAccount = bankAccount.accountNo
      //   data.ourBank = bankAccount.bankChineseName
      //   data.ourBankCurrency = bankAccount.currency
      //   data.ourBankAccountId = bankAccount.accountId
      // }
    },
    confirmedChargeChangeHandler(value) {
      this.dgCharge.gridApi.forEachNode(node => {
        if (this.cbConfirmedCharge) {
          node.setSelected(node.data.confirmState === 1)
        } else {
          node.setSelected(true)
        }
      })
    },
    // 其他币种汇率
    otherRate1ChangeHandler(value) {
      this.txtOtherRate1 = value === 0 ? undefined : value
      this.properties.otherCurrencyRate[0]['rate'] = value
      //
      this.updateChargeRates()
      this.calcTotalVerifyAmount()
    },
    otherRate2ChangeHandler(value) {
      this.txtOtherRate2 = value === 0 ? undefined : value
      this.properties.otherCurrencyRate[1]['rate'] = value
      //
      this.updateChargeRates()
      this.calcTotalVerifyAmount()
    },
    // 当前选中的费用
    onRowSelected: lodash.debounce(function(event) {
      this.dgCharge.gridApi.forEachNode(node => {
        if (node.data) {
          const charge = node.data
          if (node.selected) {
            if (charge.currentVerifiedAmount === 0) {
              charge.currentVerifiedAmount = charge.lastTimeRemainAmount
            }
            charge.currentRemainAmount = NumberUtils.roundHalfUp(charge.lastTimeRemainAmount - charge.currentVerifiedAmount, 2)
          } else {
            charge.currentVerifiedAmount = 0
            charge.currentRemainAmount = NumberUtils.roundHalfUp(charge.lastTimeRemainAmount - charge.currentVerifiedAmount, 2)
          }
        }
      })
      this.$nextTick(() => {
        this.calcTotalVerifyAmount()
        this.calcPreExchangeDifference()
      })
    }, 200, {
      trailing: true
    }),
    onRowClicked1(event) {
      this.selectedRow = event.data
      this.selectedRowMode = this.properties.writeOffMode
      this.selectedRowHedge = false
      this.toSetSelected()
    },
    onRowClicked2(event) {
      this.selectedRow = event.data
      this.selectedRowMode = this.properties.writeOffModeHedge
      this.selectedRowHedge = true
      this.toSetSelected()
    },
    // 勾选
    toSetSelected() {
      this.once.excute(this.setSelected, [], 100)
    },
    setSelected() {
      this.dgCharge.gridApi.selectAll()
      this.dgCharge.gridApi.forEachNode(node => {
        if (node.data.currentVerifiedAmount === 0) {
          node.setSelected(false)
        }
      })
    },
    getGridSelectedRows(subTotal = false) {
      const rows = []
      const allEntities = subTotal ? this.dgChargeRowData : this.properties.allEntities
      for (const charge of allEntities) {
        if (charge.currentVerifiedAmount !== 0 || (this.isInputZeroFee && charge.amount === 0)) {
          rows.push(charge)
        }
      }
      return rows
    },
    processCellForClipboard() {
      const txt = window.getSelection ? window.getSelection() : document.selection.createRange().text
      return txt
    },
    cellEventCallback(params) {
      if (params.event.target.nodeName === 'DIV' || params.event.target.nodeName === 'SPAN') {
        const selection = document.getSelection()
        const range = document.createRange()
        range.selectNode(params.event.target)
        selection.removeAllRanges()
        selection.addRange(range)
      }
    },
    bankAccountLabel(bankAccount) {
      if (bankAccount) {
        return '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName
      }
      return ''
    },
    // 选择实收实付 确定按钮事件
    enterHandler() {
      if ((!this.realSendReceiveDialog.useMultipleRecords && !this.realSendReceiveDialog.dialogClickRow) ||
          (this.realSendReceiveDialog.useMultipleRecords && (!this.realSendReceiveDialog.selectedRows || this.realSendReceiveDialog.selectedRows.length === 0))) {
        this.$message.info(this.$t('CargoMsg.Cargo_PSROACP'))
        return
      }
      if (!this.realSendReceiveDialog.useMultipleRecords) {
        const actualAmount = this.realSendReceiveDialog.dialogClickRow
        this.cancelHandler()
        this.setActualAmount(actualAmount)
      } else { // 多记录核销
        const actualAmounts = this.realSendReceiveDialog.selectedRows
        let currency = ''
        for (const item of actualAmounts) {
          if (!currency) {
            currency = item.currency
          } else {
            if (currency !== item.currency) {
              this.$message.info(this.$t('CargoMsg.Cargo_SameCurrencyForMultipleRecord'))
              return
            }
          }
        }
        let samePayReceiveDate = true
        let payReceiveDate = null
        for (const item of actualAmounts) {
          if (StrUtils.isEmpty(item.payReceiveDate)) continue
          if (!payReceiveDate) {
            payReceiveDate = item.payReceiveDate
          } else {
            const str1 = ColumnUtils.dateMonthFunc(payReceiveDate)
            const str2 = ColumnUtils.dateMonthFunc(item.payReceiveDate)
            if (str1 !== str2) {
              samePayReceiveDate = false
              break
            }
          }
        }
        if (!samePayReceiveDate) {
          if (this.properties.prePaymentVerifyCanMultiCurrency) {
            for (const row of this.dgChargeRowData) {
              if (row.currency !== currency) {
                this.$message.warning(this.$t('CargoMsg.Cargo_SamePayReceiveDateForMultipleRecord'))
                return
              }
            }
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_SamePayReceiveDateForMultipleRecord'))
            return
          }
        }
        this.cancelHandler()
        this.useMultipleRecordEvent(actualAmounts)
      }
      setTimeout(() => {
        this.calcPreExchangeDifference()
      }, 100)
    },
    // 选择实收实付 取消按钮事件
    cancelHandler() {
      this.realSendReceiveDialog.dialogClickRow = null
      this.realSendReceiveDialog.selectedRows = []
      this.realSendReceiveDialog.visible = false
    },
    async setActualAmount(selectedModel) {
      let modelRemainAmount = selectedModel.remainAmount
      await this.checkSelectedActualAmount(selectedModel)
      //
      if (selectedModel.currency !== this.writeoffCurrency) {
        const rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, selectedModel.currency, StrUtils.isEmpty(selectedModel.payReceiveDate) ? new Date() : selectedModel.payReceiveDate, selectedModel.branchId)
        modelRemainAmount = rate * modelRemainAmount
      }
      if (modelRemainAmount < this.nsActualAmount) {
        this.$confirm(this.$t('CargoMsg.Cargo_PlsInput') + NumberUtils.formatNumber(this.nsActualAmount, 2), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          return
        }).catch(() => {
          //
        })
        return
      }
      this.properties.actualAmount = selectedModel
      await this.fillViewByActualAmount()
      this.useReceiptRecord = true
      this.initOurBankAccountArray()
    },
    async checkSelectedActualAmount(selectedModel) {
      if (StrUtils.isEmpty(this.totalVerifyAmount)) this.totalVerifyAmount = 0
      this.nsActualAmount = this.totalVerifyAmount
      let modelRemainAmount = this.totalVerifyAmount
      if (selectedModel && selectedModel.currency && selectedModel.currency !== this.writeoffCurrency) {
        const rate = await RateUtil.getForeignExchangeRateSafely(selectedModel.currency, this.writeoffCurrency, StrUtils.isEmpty(selectedModel.payReceiveDate) ? new Date() : selectedModel.payReceiveDate, selectedModel.branchId)
        modelRemainAmount = rate * this.totalVerifyAmount
      }
      if (selectedModel && modelRemainAmount > selectedModel.remainAmount) {
        this.$confirm(this.arLabel + this.$t('CargoMsg.Cargo_InsufficientRecordBalance') + NumberUtils.formatNumber(this.totalVerifyAmount, 2), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'success'
        }).then(() => {
          //
        }).catch(() => {
          //
        })
      }
    },
    async fillViewByActualAmount() {
      const actualAmountRowData = this.actualAmountGrid.rowData
      if (this.properties.actualAmount && this.properties.actualAmount.uuid) {
        const _model = this.properties.actualAmount
        this.writeoffCurrency = _model.currency
        for (const item of actualAmountRowData) {
          item.writeoffCurrency = this.writeoffCurrency
          item.receiveType = _model.type
          item.cashTransferState = _model.cashTransferState
          if (this.bankAccounts !== null) {
            for (const bankAccount of this.bankAccounts) {
              if (_model.ourBankCurrency === bankAccount.currency && _model.ourBankAccount === bankAccount.accountNo) {
                item.ourBankAccount = bankAccount.accountNo
                item.ourBank = bankAccount.bankChineseName
                item.ourBankCurrency = bankAccount.currency
                item.ourBankAccountId = bankAccount.accountId
                break
              }
            }
            if (this.useReceiptRecord) {
              _model.ourBankAccount = item.ourBankAccount
              _model.ourBank = item.ourBank
              _model.ourBankCurrency = item.ourBankCurrency
              _model.ourBankAccountId = item.ourBankAccountId
            }
          }
          item.bankWaterNo = _model.bankWaterNo
          item.voucherNo = _model.voucherNo
          item.payCompany = _model.paymentCompany
          item.payBank = _model.companyBank
          item.payAccountNo = _model.companyBankAccount
          item.account = _model.accountId
        }
        if (!this.properties.kartenNumberRule || !this.properties.writeOffRemarkShowSrialNo) {
          this.txtRemark = _model.remark
        }
        this.showRecordButton = !_model.bankSlip
        if (!_model.bankSlip) {
          await this.currencyChangeEvent({ value: this.writeoffCurrency })
        }
      } else {
        for (const item of actualAmountRowData) {
          item.receiveType = 2
          item.cashTransferState = 0
          item.voucherNo = ''
          item.bankWaterNo = ''
          item.payCompany = ''
          item.payBank = ''
          item.payAccountNo = ''
        }
        if (!this.properties.kartenNumberRule || !this.properties.writeOffRemarkShowSrialNo) {
          this.txtRemark = ''
        }
      }
      // 刷新列表
      this.$nextTick(() => {
        if (this.actualAmountGrid.gridOptions && this.actualAmountGrid.gridOptions.api) {
          this.actualAmountGrid.gridOptions.api.refreshCells({ force: true })
        }
      })
    },
    // 修改其它币种汇率 - 按费用汇率
    async setOtherCurrencyRateByCharge() {
      if (this.properties.allEntities.length === 0) {
        return
      }
      const localCurrency = RateUtil.localCurrencyByOffice()
      for (const charge of this.properties.allEntities) {
        if (charge.currency === this.writeoffCurrency) {
          charge.writeoffRate = 1
        } else {
          let rate = 0
          if (this.writeoffCurrency === localCurrency) { // 按费用汇率销账，如果销账币种是RMB,则直接取费用上的汇率。如果不是RMB，需要重新获取汇率
            rate = charge.exchangeRate
          }
          if (rate === 0) {
            if (this.properties.actualAmount && !StrUtils.isEmpty(this.properties.actualAmount.payReceiveDate)) {
              rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, charge.currency, this.properties.actualAmount.payReceiveDate, this.properties.actualAmount.branchId)
            } else {
              rate = await RateUtil.getForeignExchangeRateSafely(this.writeoffCurrency, charge.currency, this.dfAmountDate, 0)
            }
          }
          charge.writeoffRate = rate
        }
      }
      // 刷新
      this.$nextTick(() => {
        this.dgCharge.gridOptions.api.refreshCells({ force: true })
      })
    },
    //
    async onActualAmountCellChange(params) {
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        originalValue: params.oldValue
      }
      if (newParams.field === 'ourBankAccountId') {
        if (newParams.value) {
          if (this.bankAccounts && this.bankAccounts.length > 0) {
            const bank = this.bankAccounts.find(item => {
              return item.accountId === newParams.value
            })
            if (bank) {
              newParams.data.ourBankAccountId = newParams.value
              newParams.data.ourBank = bank.bankChineseName
              newParams.data.ourBankAccount = bank.accountNo
              newParams.data.ourBankCurrency = bank.currency
              if (this.$store.getters.currentOffice.multiTitleBankMode) {
                if (bank.officeInvoiceTitleUuid && this.ourInvoiceTitleArray && this.ourInvoiceTitleArray.length > 0) {
                  const titleObj = this.ourInvoiceTitleArray.find(p => p.uuid === bank.officeInvoiceTitleUuid)
                  if (titleObj) {
                    this.actualAmountTitle = titleObj.invoiceTitle
                  } else {
                    this.actualAmountTitle = ''
                  }
                } else {
                  this.actualAmountTitle = ''
                }
                this.initOurBankAccountArray()
              }
            }
          }
        } else {
          newParams.data.ourBankAccountId = 0
          newParams.data.ourBank = ''
          newParams.data.ourBankAccount = ''
          newParams.data.ourBankCurrency = ''
        }
      }
      if (newParams.field === 'writeoffCurrency') {
        params.data.writeoffCurrency = newParams.value
        await this.currencyChangeEvent({ value: newParams.value })
        this.checkCurrencyBankAccount(params.data)
      }
      if (newParams.field === 'receiveType') {
        params.data.receiveType = newParams.value
        if (newParams.value === ClearingConstants.RECEIVE_TYPE_CASH.code || newParams.value === ClearingConstants.RECEIVE_TYPE_VIRTUAL_CASH.code) {
          newParams.data.ourBankAccount = ''
          newParams.data.ourBank = ''
          newParams.data.ourBankCurrency = ''
          newParams.data.ourBankAccountId = 0
          if (params.data) {
            params.data.ticketNo = ''
          }
          this.ticketNoEditDisable = false
        } else {
          // CARGO-45570 在销账时，如果选择“支票”“银行承兑汇票”“商业承兑汇票”时，额外显示“票据号”填写栏位。非必填。
          if (newParams.value === ClearingConstants.RECEIVE_TYPE_CHECK.code ||
            newParams.value === ClearingConstants.BANK_ACCEPTANCE_BILL.code ||
            newParams.value === ClearingConstants.COMMERCIAL_ACCEPTANCE_BILL.code) {
            this.ticketNoEditDisable = true
          } else {
            this.ticketNoEditDisable = false
            if (params.data) {
              params.data.ticketNo = ''
            }
          }
          this.checkCurrencyBankAccount(params.data)
        }
      }
      if (this.actualAmountGrid.gridApi) {
        this.actualAmountGrid.gridApi.refreshCells({ force: true })
      }
    },
    // 我方银行显示列转换
    ourBankLabelFunc(accountId) {
      if (accountId === 0 || !accountId || !this.bankAccounts || this.bankAccounts.length === 0) return ''
      const bank = this.bankAccounts.find(item => {
        return item.accountId === accountId
      })
      if (bank) {
        return '[' + bank.code + ']' + '[' + bank.currency + ']' + '[' + bank.bankChineseName + ']'
      }
      return ''
    },
    // 实收实付勾选回调事件
    selectionChangedCallBack(selections = null) {
      this.realSendReceiveDialog.dialogClickRow = null
      this.realSendReceiveDialog.selectedRows = []
      this.realSendReceiveDialog.useMultipleRecords = false
      if (selections && selections.length > 0) {
        if (selections.length === 1) {
          this.realSendReceiveDialog.dialogClickRow = selections[0]
          this.realSendReceiveDialog.selectedRows = []
          this.realSendReceiveDialog.useMultipleRecords = false
        } else {
          this.realSendReceiveDialog.useMultipleRecords = true
          this.realSendReceiveDialog.dialogClickRow = null
          this.realSendReceiveDialog.selectedRows = selections
        }
      }
    },
    // 使用多个记录进行销账
    async useMultipleRecordEvent(selectedModels) {
      this.properties.actualAmounts = []
      this.useReceiptRecord = false
      await this.checkSelectedActualAmountForMultiple(selectedModels)
      let modelRemainAmount = 0.00
      for (const item of selectedModels) {
        modelRemainAmount = modelRemainAmount + item.remainAmount
      }
      let totalVerifyAmount = this.nsActualAmount
      const currency = selectedModels[0].currency
      const payReceiveDate = StrUtils.isEmpty(selectedModels[0].payReceiveDate) ? new Date() : selectedModels[0].payReceiveDate
      if (currency !== this.writeoffCurrency) {
        const rate = await RateUtil.getForeignExchangeRateSafely(currency, this.writeoffCurrency, payReceiveDate, selectedModels[0].branchId)
        totalVerifyAmount = rate * totalVerifyAmount
      }
      if (modelRemainAmount < totalVerifyAmount) {
        await this.$confirm(this.$t('CargoMsg.Cargo_PlsInput') + NumberUtils.formatNumber(this.nsActualAmount, 2), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          return
        }).catch(() => {
        })
        return
      }
      this.useReceiptRecord = true
      this.initOurBankAccountArray()
      await this.fillViewByMultipleActualAmount(selectedModels)
    },
    async checkSelectedActualAmountForMultiple(selectedModels) {
      if (!this.totalVerifyAmount) this.totalVerifyAmount = 0
      this.nsActualAmount = this.totalVerifyAmount
      let modelRemainAmount = this.totalVerifyAmount
      let totalRemainAmount = 0.00
      const currency = selectedModels[0].currency
      const payReceiveDate = StrUtils.isEmpty(selectedModels[0].payReceiveDate) ? new Date() : selectedModels[0].payReceiveDate
      if (currency !== this.writeoffCurrency) {
        const rate = await RateUtil.getForeignExchangeRateSafely(currency, this.writeoffCurrency, payReceiveDate, selectedModels[0].branchId)
        modelRemainAmount = rate * this.totalVerifyAmount
      }
      for (const item of selectedModels) {
        totalRemainAmount = totalRemainAmount + item.remainAmount
      }
      let passThrough = true
      if (selectedModels && modelRemainAmount > totalRemainAmount) {
        let message = ''
        if (this.isAr) {
          message = this.$t('CargoMsg.Cargo_WriteOffForMultipleRemainTipAr')
        } else {
          message = this.$t('CargoMsg.Cargo_WriteOffForMultipleRemainTipAp')
        }
        await this.$confirm(message, this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          passThrough = false
        }).catch(() => {
          passThrough = false
        })
      }
      return passThrough
    },
    async fillViewByMultipleActualAmount(selectedModels) {
      const writeOffModel = this.actualAmountGrid.rowData[0]
      this.actualAmountGrid.rowData = []
      let bankSlip = false
      this.writeoffCurrency = selectedModels[0].currency
      for (const actualAmount of selectedModels) {
        const row = new WriteOffModel().fillDefaultValue().getData()
        Object.assign(row, writeOffModel)
        row.writeoffCurrency = this.writeoffCurrency
        row.receiveType = actualAmount.type
        row.cashTransferState = actualAmount.cashTransferState
        row.account = actualAmount.accountId
        if (this.bankAccounts !== null) {
          for (const bankAccount of this.bankAccounts) {
            if (actualAmount.ourBankCurrency === bankAccount.currency && actualAmount.ourBankAccount === bankAccount.accountNo) {
              row.ourBankAccount = bankAccount.accountNo
              row.ourBank = bankAccount.bankChineseName
              row.ourBankCurrency = bankAccount.currency
              row.ourBankAccountId = bankAccount.accountId
              actualAmount.ourBankAccount = bankAccount.accountNo
              actualAmount.ourBank = bankAccount.bankChineseName
              actualAmount.ourBankCurrency = bankAccount.currency
              actualAmount.ourBankAccountId = bankAccount.accountId
              break
            }
          }
        }
        row.voucherNo = actualAmount.voucherNo
        row.bankWaterNo = actualAmount.bankWaterNo
        row.payCompany = actualAmount.paymentCompany
        row.payBank = actualAmount.companyBank
        row.payAccountNo = actualAmount.companyBankAccount
        if (actualAmount.bankSlip) {
          bankSlip = true
        }
        if (!this.properties.kartenNumberRule || !this.properties.writeOffRemarkShowSrialNo) {
          if (!this.txtRemark) {
            this.txtRemark = actualAmount.remark
          } else {
            this.txtRemark = this.txtRemark + ';' + actualAmount.remark
          }
        }
        this.actualAmountGrid.rowData.push(row)
      }
      // 刷新
      this.$nextTick(() => {
        this.dgCharge.gridOptions.api.refreshCells({ force: true })
      })
      this.properties.actualAmount = selectedModels[0]
      this.properties.actualAmounts = selectedModels
      this.showRecordButton = !bankSlip
      if (!bankSlip) {
        await this.currencyChangeEvent({ value: this.writeoffCurrency })
      }
    },
    //
    async writeOffByMultipleActualAmount() {
      if (!this.properties.actualAmounts || this.properties.actualAmounts.length === 0) {
        this.loading.close()
        this.isLoading = false
        this.$message.warning(this.$t('CargoMsg.Cargo_PSROACP'))
      }
      let modelRemainAmount = this.totalVerifyAmount
      const currency = this.properties.actualAmounts[0].currency
      const payReceiveDate = StrUtils.isEmpty(this.properties.actualAmounts[0].payReceiveDate) ? new Date() : this.properties.actualAmounts[0].payReceiveDate
      if (currency && currency !== this.writeoffCurrency) {
        const rate = await RateUtil.getForeignExchangeRateSafely(currency, this.writeoffCurrency, payReceiveDate, this.properties.actualAmounts[0].branchId)
        modelRemainAmount = rate * this.totalVerifyAmount
      }
      let totalRemainAmount = 0.00
      for (const item of this.properties.actualAmounts) {
        totalRemainAmount = totalRemainAmount + item.remainAmount
      }
      const bankSlip = this.properties.actualAmounts[0].bankSlip
      if (!this.dfAmountDate) {
        this.loading.close()
        this.isLoading = false
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.arLabel + this.$t('CargoMsg.Cargo_Date'))
        return
      } else if (modelRemainAmount > totalRemainAmount) {
        this.loading.close()
        this.isLoading = false
        this.$message.warning(this.$t('CargoMsg.Cargo_InsufficientRecordBalance') + this.totalVerifyAmount)
        return
      } else if (bankSlip && this.properties.actualAmount.remainAmount < this.totalVerifyAmount) {
        this.loading.close()
        this.isLoading = false
        this.$message.warning(this.$t('CargoMsg.Cargo_BOPIOOPCTBLTCWOA'))
        return
      } else {
        const writeoffCharge = this.getGridSelectedRows()
        if (writeoffCharge.length === 0) {
          this.loading.close()
          this.isLoading = false
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToWriteOff'))
          return
        }
      }

      let count = 0
      if (this.properties.currencys.indexOf(this.writeoffCurrency) !== -1) {
        count = this.properties.currencys.length
      } else {
        count = this.properties.currencys.length + 1
      }
      if (count > 3) {
        this.loading.close()
        this.isLoading = false
        this.$message.warning(this.$t('CargoMsg.Cargo_NMT2MCTAIEAWO'))
        return
      }

      // if (this.properties.writeoffCheckBillpaymentDone) {
      //   if ((this.properties.entities.length > 0 && this.classType !== 'billPayment' && !this.checkBillPayment(this.properties.entities)) ||
      //       (this.properties.isHedge && this.properties.hedgeEntities.length > 0 && this.hedgeType !== 'billPayment' && !this.checkBillPayment(this.properties.hedgeEntities))) {
      //     this.loading.close()
      //     this.isLoading = false
      //     this.$message.warning(this.$t('CargoMsg.Cargo_OFAOPOTFSIITPRPPDNOATRIC'))
      //     return
      //   }
      // }
      // CARGO-897，销账银行账号与销账币种不匹配
      let isSameCurrency = true
      if (!StrUtils.isEmpty(this.writeoffCurrency) && !StrUtils.isEmpty(this.txtOurBankAccount)) {
        if (this.bankAccounts !== null) {
          isSameCurrency = false
          for (const bankAccount of this.bankAccounts) {
            if (!StrUtils.isEmpty(bankAccount.currency) && this.writeoffCurrency === bankAccount.currency && !StrUtils.isEmpty(bankAccount.accountNo) && this.txtOurBankAccount === bankAccount.accountNo) {
              isSameCurrency = true // 币种相同
              break
            }
          }
        }
      }
      if (!isSameCurrency) {
        await this.$confirm(this.$t('CargoMsg.Cargo_TSBADNCTCC'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          await this.writeOffConfirm()
        }).catch(() => {
        }).finally(() => {
          this.loading.close()
          this.isLoading = false
        })
      } else {
        await this.writeOffConfirm()
      }
    },
    async doWriteOffByByMultipleActualAmountHandler() {
      const actualAmounts = this.properties.actualAmounts
      // 按照余额从大到小排序
      const newActualAmount = actualAmounts.sort((a, b) => {
        const amountA = isNaN(a.remainAmount) ? 0.0 : Number(a.remainAmount)
        const amountB = isNaN(b.remainAmount) ? 0.0 : Number(b.remainAmount)
        return amountB - amountA
      })
      const isArIncluded = this.properties.isEntitiesAr
      const isApIncluded = !this.properties.isEntitiesAr
      let totalAmount = this.nsActualAmount
      const lastActualAmounts = [] // 最终参与计算的所有的实收实付记录
      const localCurrency = RateUtil.localCurrencyByOffice()
      for (const model of newActualAmount) {
        model.arIncluded = isArIncluded
        model.apIncluded = isApIncluded
        if (model.verificationBy === 0) {
          if (model.rate === 0) {
            model.rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, model.currency, StrUtils.isEmpty(model.payReceiveDate) ? new Date() : model.payReceiveDate, 0)
            this.rateUpdateModel.push(model)
          }
          model.verificationBy = this.$store.getters.userId
          model.verificationByDep = this.$store.getters.currentDeptId
          model.verificationDate = new Date()
        }
        // 多结算单位进行销账，生成的实收实付单中accountId等于0（此时弹出窗口名称固定为“销账”）
        if (this.$t('CargoMsg.Cargo_WriteOff') === this.title) {
          if (this.properties.writeoffByDifferentAccount) {
            if (!ClearingUtils.isSameAccount(this.properties.entities)) {
              model.accountId = 0
            } else {
              if (!model.uuid) model.accountId = (this.properties.accountId === 0) ? this.properties.entities[0].accountId : this.properties.accountId
            }
          } else {
            if (model.accountId === 0) {
              model.accountId = (this.properties.accountId === 0) ? this.properties.entities[0].accountId : this.properties.accountId
            }
          }
        } else {
          if (this.$t('CargoMsg.Cargo_OverseasWriteOff') === this.title && this.properties.writeoffByDifferentAccount && !ClearingUtils.isSameAccount(this.properties.entities)) {
            model.accountId = 0
          } else {
            if (model.accountId === 0) {
              model.accountId = (this.properties.accountId === 0) ? this.properties.entities[0].accountId : this.properties.accountId
            }
          }
        }
        if (totalAmount && totalAmount > 0) { // 当本地核销金额大于0时，进行判断
          if (NumberUtils.roundHalfUp(totalAmount - model.remainAmount) > 0) { // 全部核销
            totalAmount = NumberUtils.roundHalfUp(totalAmount - model.remainAmount)
            lastActualAmounts.push(model)
          } else if (NumberUtils.roundHalfUp(totalAmount - model.remainAmount) === 0) {
            totalAmount = NumberUtils.roundHalfUp(totalAmount - model.remainAmount)
            lastActualAmounts.push(model)
          } else if (NumberUtils.roundHalfUp(totalAmount - model.remainAmount) < 0) {
            totalAmount = NumberUtils.roundHalfUp(totalAmount - model.remainAmount)
            lastActualAmounts.push(model)
            break
          }
        } else { // 本次核销金额等于0，随机取一个实收付记录就可以了
          lastActualAmounts.push(model)
          break
        }
      }
      const map = {}
      const writeoffCharges = []
      const hedgeCharges = []
      const classType = this.classType
      const hedgeType = this.hedgeType
      this.checkWriteoffCharges(this.properties.entities, writeoffCharges, map)
      if (writeoffCharges.length === 0) {
        this.$confirm(this.$t('CargoMsg.Cargo_ExpenseWriteOffCanTBeEmpty'), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).finally(() => {
          this.loading.close()
          this.isLoading = false
        })
        return
      }
      // 本次收/付金额+汇总损益+财务费用+零头短账，与本次核销金额校对
      map['actualAmount'] = this.nsActualAmount
      map['clearOdd'] = this.nsClearOdd
      map['diffChange'] = this.nsDiffChange
      map['financialCost'] = this.nsFinancialCost
      if (this.isExecuting) return
      const requestBody = {
        'chargeKeys': writeoffCharges,
        'hedgeChargeKeys': hedgeCharges,
        'writeoffType': classType,
        'hedgeType': hedgeType,
        'actModels': lastActualAmounts,
        'clearAmountMap': map,
        'currentOfficeId': this.$store.getters.currentOfficeId,
        'location': this.location
      }
      if (!this.loading) {
        this.loading = getLoading()
      }
      this.executing = true
      await chargeWriteoffByMultiple(requestBody).then(res => {
        this.chargeWriteoffSuccess(res)
      }).finally(() => {
        this.executing = false
        this.isLoading = false
        this.loading.close()
      })
    },
    // 计算预估汇差
    async calcPreExchangeDifference() {
      if (this.properties.allEntities.length === 0) {
        return
      }
      this.preExchangeDifference = 0
      const localCurrency = RateUtil.localCurrencyByOffice()
      for (const charge of this.properties.allEntities) {
        if (charge.currency === localCurrency || charge.currentVerifiedAmount === 0) continue
        // 当时日期
        let beforeDate
        // 收付日期
        let currentDate = this.dfAmountDate
        if (this.properties.actualAmount && !StrUtils.isEmpty(this.properties.actualAmount.payReceiveDate)) { currentDate = this.properties.actualAmount.payReceiveDate }
        // 当前汇率
        let key = charge.currency + moment(currentDate).format('yyyyMM')
        if (this.preExchangeDiffRateMap[key]) {
          charge.currentRate = this.preExchangeDiffRateMap[key]
        } else {
          charge.currentRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, charge.currency, currentDate, 0)
          this.preExchangeDiffRateMap[key] = charge.currentRate
        }
        let sign = 1
        // 当时汇率
        let rate = 0
        switch (this.properties.writeOffMode) {
          case 1: // 费用
            beforeDate = charge.businessDate
            break
          case 2: // 发票
            beforeDate = charge.invoiceDate
            if (charge.invoiceCurrency === localCurrency) {
              if (charge.invoiceChargeCurrency1 === charge.currency) {
                rate = charge.invoiceChargeExchangeRate1
              } else if (charge.invoiceChargeCurrency2 === charge.currency) {
                rate = charge.invoiceChargeExchangeRate2
              }
            }
            break
          case 3: // 账单
            beforeDate = charge.billingInputDate
            if (charge.billingCurrency === localCurrency) {
              if (charge.billingSourceCurrency1 === charge.currency) {
                rate = charge.billingSourceRate1
              } else if (charge.billingSourceCurrency2 === charge.currency) {
                rate = charge.billingSourceRate2
              } else if (charge.billingSourceCurrency3 === charge.currency) {
                rate = charge.billingSourceRate3
              }
            }
            break
          case 4: // 对账单
            beforeDate = charge.billingGroupInputDate
            break
          case 5: // 付款申请
            beforeDate = charge.billPaymentInputDate
            if (charge.billPaymentCurrency === localCurrency) {
              if (charge.billPaymentOtherCurrency === charge.currency) {
                rate = charge.billPaymentRate
              }
            }
            break
        }
        if (rate === 0) {
          key = charge.currency + moment(beforeDate).format('yyyyMM')
          if (this.preExchangeDiffRateMap[key]) {
            rate = this.preExchangeDiffRateMap[key]
          } else {
            rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, charge.currency, beforeDate, 0)
            this.preExchangeDiffRateMap[key] = rate
          }
        }
        charge.beforeRate = rate
        // 预估汇差
        charge.preExchangeDifference = 0
        if (charge.currentRate !== 0 && charge.beforeRate !== 0 && charge.currentRate !== charge.beforeRate) {
          sign = charge.isReceivable ? 1 : -1
          charge.preExchangeDifference = NumberUtils.roundHalfUp(charge.currentRate * charge.currentVerifiedAmount * sign) - NumberUtils.roundHalfUp(charge.beforeRate * charge.currentVerifiedAmount * sign)
          charge.preExchangeDifference = NumberUtils.roundHalfUp(charge.preExchangeDifference)
          //
          this.preExchangeDifference += charge.preExchangeDifference
          this.preExchangeDifference = NumberUtils.roundHalfUp(this.preExchangeDifference)
        }
      }
    },
    fullscreenChange() {
      setTimeout(() => {
        this.dgGroup.gridApi.sizeColumnsToFit()
        if (this.properties.isHedge) {
          this.dgHedge.gridApi.sizeColumnsToFit()
        }
      }, 100)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    txtRemarkFinshHandlde(val) {
      this.txtRemark = val
      if (this.txtRemark === '') return
      if (this.txtRemark.endsWith('\r') || this.txtRemark.endsWith('\n')) {
        this.txtRemark = this.txtRemark.substring(0, this.txtRemark.length - 1)
      }
    },
    refreshTxtRemarks() {
      if ((!this.properties.actualAmount || !this.properties.actualAmount.uuid) && this.isAr &&
        !this.properties.kartenNumberRule && this.properties.writeOffRemarkShowSrialNo) {
        generateSeqNoByWriteOffRemarkNo({
          payDate: this.dfAmountDate,
          branchId: this.$store.getters.currentOfficeId
        }).then(res => {
          this.txtRemark = res.data.seqNo
        })
      }
    }
  }
}
String.prototype.format = function() {
  if (arguments.length === 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) {
    s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i])
  }
  return s
}
</script>

<style lang="scss">
.write-off-dialog {
  width: 1150px;

  .el-scrollbar__wrap {
    overflow-x: auto;
  }

  .el-dialog__body {
    padding: 0 !important;
  }

  .inner-row-border-bottom {
    margin-bottom: 8px;
    border-bottom: 1px solid gray;
  }

  .custom-el-form-item-color-red {
    .el-form-item__label {
      color: #990000;
    }

    .el-form-item__content {
      .el-input input {
        color: #990000;
      }
    }
  }

  .custom-el-form-item-color-green {
    .el-form-item__label {
      color: #009900;
    }

    .el-form-item__content {
      .el-input input {
        color: #009900;
      }
    }
  }

  .el-form-item-w160 {
    width: 160px;
    margin-right: 5px;
    margin-bottom: 4px !important;

    .el-form-item__content {
      width: 100px;

      .el-input__inner {
        padding: 0px 4px;
      }

      .cargo-advance-select-wrapper {
        .el-input__inner {
          padding: 0px 37px 0 4px;
        }
      }
    }
  }

  .el-form-item-w180 {
    width: 200px;
    margin-right: 5px;
    margin-bottom: 4px !important;

    .el-form-item__content {
      width: 140px;

      .el-input__inner {
        padding: 0px 4px;
      }

      .el-input-number.is-controls-right .el-input__inner {
        padding-left: 5px;
        padding-right: 35px;
      }

      .cargo-advance-select-wrapper {
        .el-input__inner {
          padding: 0px 37px 0 4px;
        }
      }
    }
  }

  .el-form-item-date-w180 {
    width: 180px;
    margin-right: 5px;
    margin-bottom: 4px !important;

    .el-form-item__content {
      width: 120px;

      .el-input__inner {
        padding-left: 35px;
        padding-right: 5px;
      }
    }
  }

  .el-form-item-w200 {
    width: 200px;
    margin-right: 5px;
    margin-bottom: 4px !important;

    .el-form-item__content {
      width: 140px;

      .el-input__inner {
        padding: 0px 4px;
      }

      .cargo-advance-select-wrapper {
        .el-input__inner {
          padding: 0px 37px 0 4px;
        }
      }
    }
  }

  .el-form-item-w250 {
    width: 250px;
    margin-right: 5px;
    margin-bottom: 4px !important;

    .el-form-item__content {
      width: 190px;

      .el-input__inner {
        padding: 0 4px;
      }

      .cargo-advance-select-wrapper {
        .el-input__inner {
          padding: 0px 37px 0 4px;
        }
      }
    }
  }

  .el-form-item-w365 {
    width: 365px;
    margin-right: 5px;
    margin-bottom: 4px !important;

    .el-form-item__content {
      width: 305px;

      .el-input__inner {
        padding: 0px 4px;
      }
    }
  }

  .ag-theme-balham {
    .ag-cell {
      user-select: text;
    }
  }
}

// 英文样式
#app.en {
  .write-off-dialog {
    .el-form-item-w180 {
      width: 230px;
    }
  }
}
</style>
